import React from 'react';

export default function SamaUpakarmaPage() {
  return (
    

<div className="page-content container mx-auto p-4">
  <h1>ஸாம உபாகர்மா</h1>
  <div className="div3">
    <h2>ஸாம உபாகர்மா முழு வீடியோ</h2>
    <ion-item>
      <div className="video-container">
        <iframe src="https://www.youtube.com/embed/M1xqAR7EeQo?rel=0" frameborder="0" width="300" height="169"></iframe>
      </div>
      </ion-item>
    {/* https://youtu.be/M1xqAR7EeQo */}
  </div>
  <div>
    <div className="tab-section my-8">
<h2 className="text-2xl font-bold mb-4">தமிழ்</h2>
      <div className="svk">ஆசமனம்</div>
      <div className="hint">ஆசமனம், ப்ராணாயாமம் அடிக்கடி
        செய்யவேண்டியிருக்கும், எனவே, இதை நன்றாகத்
        தெரிந்து வைத்துக்கொண்டு கர்மாவைச் செய்தால்
        விரைவாகவும், சிறப்பாகவும் செய்யலாம்.
        </div>
      <hr />
      <div>
        <img src="assets/img/achamanam.gif" />
      </div>
      <div className="svk2">Achamanam - Audio </div>
          <audio controls>
          <source src="https://www.brahminsnet.com/upakarma/audio/achamanam.ogg" type="audio/ogg" />
            <source src="https://www.brahminsnet.com/upakarma/audio/mp4/achamanam.mp4" type="audio/mp4" />
        Your browser does not support the audio element.
        </audio>
      <div className="hint">ஒரு நாளில், ஒரு கர்மாவின்
        ஆரம்பத்திலும், முடிவிலும் இரண்டு முறை
        ஆசமனம் செய்யவேண்டும். இடையிடையே
        ஒவ்வொரு முறை செய்தால் போறும்.
        </div>
        <hr />
      <div className="sans">
        ओं अच्युताय नम:। ओं अनन्ताय नम:। <br />
        ओं गोविन्दााय नम:।<br />
        <div className="grid">
          <div className="flex flex-row flex-wrap">
            <div className="sans">ओं केशवाय नम:। </div>
            <div className="sans">नारायणाय नम:।</div>
          </div>
          <div className="flex flex-row flex-wrap">
            <div className="sans">माधवाय नम:।</div>
            <div className="sans">गोविन्दाय नम:।</div>
          </div>
          <div className="flex flex-row flex-wrap">
            <div className="sans">विष्णवे नम:। </div>
            <div className="sans">मधुसूदनाय नम:।
             </div>
          </div>
          <div className="flex flex-row flex-wrap">
            <div className="sans"> त्रिविक्रमाय नम:। </div>
            <div className="sans">वामनाय नम:।
              </div>
          </div>
          <div className="flex flex-row flex-wrap">
            <div className="sans">श्रीधराय नम:। </div>
            <div className="sans">हृषीकेशाय नम:।
              </div>
          </div>
          <div className="flex flex-row flex-wrap">
            <div className="sans">पद्मनाभाय नम:। </div>
            <div className="sans">दामोदराय नम:।</div>
          </div>
        </div>
         </div>
      <hr />
      <div>
          <img src="assets/img/Praanaayaamam1.jpg" className="img2" />
    
          <div className="hint">மணையில் இரு தர்பங்களை ஆசனமாகப்
            போட்டுக்கொண்டு, அதன்மேல் கிழக்கு நோக்கி அமரவும்.
            </div>
        </div>
        <hr />
        <div>
          <img src="assets/img/Praanaayaamam2.jpg" className="img2" />
    
          <div className="hint">இரு தர்பங்களாலான பவித்திரத்தை,
            வலது மோதிர விரலில் அணிந்து, அதனுடன் இரு
            தர்பங்களைச் சேர்த்து இடுக்கிக்கொள்ளவும்.
            </div>
        </div>
        <div className="clear"></div><hr />
    
    
        <div>
          <img src="assets/img/Praanaayaamam3.jpg" className="img2" />
    
          <div className="hint">வலது மூக்குத் துவாரத்தை, வலது
            கட்டை விரலால் அழுத்தி அடைக்கவும்.
          </div>
        </div>
    
        <div className="clear"></div><hr />
        <div>
          <img src="assets/img/Praanaayaamam4.jpg" className="img2" />
          <div className="hint"> வாயை நன்கு மூடி,
            சுட்டு விரல், நடு விரல்களை உள்ளே மடித்து,
            இட மூக்குத் துவாரம் வழியாக, வெளிக்காற்றை,
            முடிந்தவரை உள்ளிழுத்து நிறுத்தி,
            மோதிர, சுண்டு விரல்களால், இடமூக்குத் துவாரத்தையும்
            நன்கு அடைத்து ப்ராணாயாம மந்திரத்தை 3 முறை சொல்லவும்.
            </div>
        </div>
        <div className="clear"></div><hr />
        <div className="svk2">Pranayamam - Audio </div>
        <audio controls>
        <source src="https://www.brahminsnet.com/upakarma/audio/03-pranayamam1.ogg" type="audio/ogg" />
          <source src="https://www.brahminsnet.com/upakarma/audio/mp4/03-pranayamam1.mp4" type="audio/mp4" />
      Your browser does not support the audio element.
      </audio>
        <div className="prayogam">
          ஓம் பூ: ஓம் புவ: ஓகும்ஸுவ: ஓம் மஹ: ஓம் ஜன: ஓம் தப: ஓம் ஸத்யம்,
          தத்ஸவிதுர்வரேண்யம் பர்கோதேவஸ்யதீமஹி தியோயோந:ப்ரசோதயாத் ஓமாப: ஜ்யோதீரஸ:
         அம்ருதம் ப்ரஹ்மா பூர்புவஸ்ஸுவரோம்.
        </div>
      <hr />
      <div className="head2">ப்ராணாயாமம்</div>
      <hr />
      <div className="sans">
        ओं भू:। ओं भुव:। ओँसुव:। ओं मह:। ओं जन:। ओं तप:। ओँसत्यम्। ओं तत्सवितुर्वरेण्यं भर्गो देवस्य धीमहि । धियो यो न: प्रचोदयात्।
        ओमापो ज्योती रसोऽमूतं ब्रह्म भूर्भुवस्वरोम्।।
      </div>
     <hr />
    
      <div>
        <img src="assets/img/praanaayaamam.gif" />
      </div>
    
    
      <div className="item">வடகலை ஆரம்பம்</div>
    <hr />
      <div>
        <img src="assets/img/kaikoopu.jpg" className="img2" />
        <div className="hint">கையைக் கூப்பிக்கொண்டு
          மந்திரங்களைச் சொல்ல ஆரம்பிக்கவும்.
        </div>
      </div>
    <hr />
    <div className="svk2">VK-Begin - Audio </div>
          <audio controls>
          <source src="https://www.brahminsnet.com/upakarma/audio/04-vkbegining.ogg" type="audio/ogg" />
            <source src="https://www.brahminsnet.com/upakarma/audio/mp4/04-vkbegining.mp4" type="audio/mp4" />
        Your browser does not support the audio element.
        </audio>
      <div className="prayogam">ஓம் அஸ்மத் குருப்யோ நம: ஸ்ரீமான் வேங்கட நாதார்ய:
         கவிதார்கிக கேசரி வேதாந்தாசார்ய வர்யோமே ஸந்நிதத்தாம்
         ஸதாஹ்ருதி குருப்ய: தத்குருப்யஸ்ச்ச நமோவாகம் அதீமஹே
         வ்ருணீமஹேச தத்ராத்யௌ தம்பதி ஜகதாம்பதி ஸ்வசேஷ
         பூதேநமயா ஸ்வீயை: ஸர்வபரிச்சதை:
        விதாதும் ப்ரீதமாத்மாநம் தேவ: ப்ரக்ரமதே ஸ்வயம்.</div>
        <hr />
      <div className="sans">
        ओं अस्मत्गुरुभ्या नम:। श्रीमान् वेङ्कटनाथार्य: कवितार्किककेसरी। वेवान्ताचार्यवर्यो मे सिन्नधत्तां सदाहृदि|| गुरुभ्य: तद्गुरुभ्यश्च
        नमोवाकं अधीमहे। वृणीमहे च तत्राद्यौ दम्पती जगतां पती ।। स्वशेष भूतेन मया स्वीयै: सर्वपरिच्छदै: । विधातुं प्रीतमात्मानं
        देव: प्रक्रमते स्वयम् ।।
    
      </div>
      <hr />
      <div className="item">தென்கலை, ஸ்மார்த்தா ஆரம்பம் வடகலை தொடர்ச்சி</div>
      <div className="svk2">Suklambaradharam - Audio </div>
      <audio controls>
      <source src="https://www.brahminsnet.com/upakarma/audio/05-suklambara.ogg" type="audio/ogg" />
        <source src="https://www.brahminsnet.com/upakarma/audio/mp4/05-suklambara.mp4" type="audio/mp4" />
    Your browser does not support the audio element.
    </audio>
      <div className="prayogam">
          சுக்லாம்பரதரம் விஷ்ணும் சசிவர்ணம் சதுர்புஜம் ப்ரஸன்னவதனம்
          த்யாயேது ஸர்வவிக்னோபசாந்தயே யஸ்யத்விரத வக்த்ராத்யா:
          பாரிஷத்யா:       பரஸ்சதம் விக்னம் நிக்னந்தி சததம்
          விஷ்வக்ஸேனம் தமாச்ரயே.
      </div>
      <hr />
      <div className="sans">
        शुक्लाम्बरधरं विष्णुं शशिवर्णं चतुर्भुजम् । प्रसन्नवदनं ध्यायेत् सर्वविघ्नोपशान्तये ।। यस्यद्विरदवक्त्राद्या: पारिषद्या:
        पर:शतम् । विघ्नं निघ्नन्ति सततं विष्वसेनं तमाश्रये ।।
    
      </div>
    <hr />
      <div>
        <img src="assets/img/Sankalpam.jpg" className="img2" />
        <div className="hint">வலது தொடையில் இடதுகைமேல்
          வலது கைவைத்து</div>
      </div>
    
      <div className="clear"></div><hr />
      <div className="prayogam"> ஹரிரோம்தத்<br />
        ஸ்ரீ கோவிந்தா கோவிந்த கோவிந்தா அஸ்யஸ்ரீ பகவத: மஹாபுருஷ்ஸ்ய
         விஷ்ணோராஜ்ஞயா ப்ரவர்த்தமானஸ்ய ஆத்ய ப்ரஹ்மண:
         த்விதீயபரார்த்தே
        ஸ்ரீ ஸ்வேதவராஹ கல்பே வைவஸ்வத மன்வந்தரே
        கலியுகே ப்ரதமே பாதே
      </div>
      <div className="svk2">HariromTat - Audio </div>
      <audio controls>
      <source src="https://www.brahminsnet.com/upakarma/audio/06-gensankalpam.ogg" type="audio/ogg" />
        <source src="https://www.brahminsnet.com/upakarma/audio/mp4/06-gensankalpam.mp4" type="audio/mp4" />
    Your browser does not support the audio element.
    </audio>
    
      <div className="svk">இந்தியாவில் இருப்பவர்கள்</div>
      <div className="prayogam"> ஜம்பூத்வீபே பாரதவர்ஷே பரதக்கண்டே
    
      </div>
    
      <div className="svk">
          வெளிநாட்டில் இருப்பவர்கள் :
          த்வீபம் வர்ஷம் கண்டம் தெரியாதவர்கள் “விஷ்ணு” என்பதை
          உபயோகித்துக்கொள்ளலாம். அதாவது “விஷ்ணு த்வீபே”
          “விஷ்ணு வர்ஷே”, “விஷ்ணு கண்டே” என்று சொல்லலாம்
    
      </div>
    <hr />
      <div className="svk">எல்லோரும் சொல்லவும்</div>
      <div className="prayogam">சகாப்தே மேரோ: தக்ஷிணே பார்சவே அஸ்மின்
        வர்தமானானாம் வ்யவஹாரிகானாம் ப்ரபவாதீநாம் ஷஷ்டி
        ஸம்வத்ஸராணாம் மத்யே
        .....</div>
        <hr />
      <div className="sans">
        हरि: ओं तत् (सत्) श्रीगोविन्द गोविन्द गोविन्द। अस्य श्रीभगवत: महापुरुषस्य श्रीविष्णो: आज्ञया प्रवर्तमानस्य अद्यब्रह्मण: द्वितीयपराार्धे
        श्रीश्वेतवराहकल्पे वैवस्त्वत मन्वन्तरे कळियुगे प्रथमेपादे जम्बूद्वीपे भारतवर्षे भरतखण्डे शकाब्दे मेरो: दक्षिणेपार्श्वे
        अस्मिन् वर्तमानानां व्यवहारिकाणां प्रभवादीनां षष्टिसंवत्सराणां मध्ये
      </div>
      <div className="clear"></div>
    
    <hr />
      <div className="head2">
     13-09-2026 க்கான ஸங்கல்பம்:
      </div>
      <div className="svk2">13-09-2026-Sankalpam - Audio </div>
        <audio controls>
        <source src="/assets/audio/13-09-2026.mp3" type="audio/mp3" />
      Your browser does not support the audio element.
      </audio>
      <hr />
    
      <div className="prayogam">பராபவ நாம ஸம்வத்ஸரே<hr />
        - தக்ஷிணாயனே - <hr />
        வர்ஷ ருதௌ - <hr />
        ஸிம்ஹ மாஸே - <hr />
        சுக்ல பக்ஷே -<hr />
        துவிதீயாயாம் (8.25 வரை அதன் பின் த்ருதீயாயாம்) சுப திதௌ- <hr />
        வாஸர: பானு வாஸர (ஞாயிறு வாஸர) யுக்தாயாம்<hr />
        - ஹஸ்த நக்ஷத்ர (15.12 வரை) யுக்தாயாம் - <hr />
        சுப்ர யோக யுக்தாயாம் - <hr />
        கௌலவ (8.25 வரை அதன் பின் கரச) கரண யுக்தாயாம் - <hr />
        ஏவங்குண, விசேஷண விசிஷ்டாயாம் - <hr />
        அஸ்யாம்
         துவிதீயாயாம் (த்ருதீயாயாம்) சுப திதௌ
      </div>
      <hr />
      <div className="sans">
        .... पराभव नाम संवत्सरे ... दक्षिणयने - वर्ष ऋतौ
        .... सिंह मासे शुक्ल पक्षे द्वितीयायां (8.25 am after that तृतीयायां)
        शुभ तिथौ वासर: भानु वासर युक्तायां
        हस्त नक्षत्र (till 15.12) युक्तायां शुभ्र योग युक्तायां
        कौलव (8.25 am after that करस) करण युक्तायां एवङ्गुण विशेषण
        विशिष्टायां अस्यां द्वितीयायां (तृतीयायां) शुभ
        तिथौ श्रीभगवदाज्ञया श्रीमन्नारायण प्रीत्यर्थं
      </div>
    
    
         <div className="mydiv">ஸ்ரீ-ம் (குறிப்பு:- இதுபோல் ஸ்ரீ-ம் என்று உள்ள இடங்களிலெல்லாம்
        <br /> வடகலையார் ஸ்ரீபகவதாஜ்ஞயா ஸ்ரீமந் நாராயண ப்ரீத்யர்த்தம் என்றும்,
        <br /> தென்கலையார் ஸ்ரீபகவதாஜ்ஞயா ஸ்ரீபகவத் கைங்கர்யம் என்றும்,
        <br /> ஸ்மார்த்தா மமோ பார்த்த சமஸ்த துரிதக்ஷய த்வாரா
        ஸ்ரீ பரமேஸ்வர ப்ரீத்யர்த்தம் என்றும் சொல்லிக் கொள்ளவும்) </div>
        <div className="clear"></div>
    
    <hr />
         <div className="bigdiv">
        ஸாம வேதிகளுக்கு
        கமோகார்ஷீத் ஜபம் கிடையாது.
      <br />ஸாம வேத ப்ரயோகப்படி கடைசியில்தான்
      பூணல் மாற்றிக்கொள்ளவேண்டும் என்பதால்
      கடைசியில் தரப்பட்டுள்ளது. <hr className="new" />
      முதலில் மாற்றிக்கொள்ள விரும்புகிறவர்கள்,
      அதற்கான ஸங்கல்பத்தை இறுதியில்பார்த்து
      பூணல் போட்டுக்கொண்டு இங்கிருந்து தொடரவும்.
    
    </div>
    
    <div className="svk2">ஶ்ரீபகவதாஜ்ஞயா ..... ம்   ப்ரோஷ்டபத்யாம்
     ஹஸ்தர்க்க்ஷே தைஷ்யாம் பௌர்ணமாஸ்யம் கர்தவ்ய
     அத்யாய உத்ஸர்ஜன கர்மாங்கம் தேவருஷி பித்ரு ப்ரீத்யர்த்தம்
     தேவருஷி  பித்ரு தர்பணம் கரிஷ்யே! இடுக்குப் பில்லை (இருந்தால்)
     இடது பக்கம் வடக்கே எரிந்துவிடவும்.</div>
    <hr className="new" />
    
     <div className="hint"> தேவ தர்பணம் உபவீதி  (வழக்கம்போல்)
       இரண்டு எருக்கு இலை மேல் இரு தர்பங்களை வைத்துக்கொண்டு
       அதில் அக்ஷதை சேர்த்துக்கொண்டு, ஒவ்வொரு தர்பணத்திற்கும்
       சிறிது சிறிதாக ஜலம் சேர்த்து <span style={{"backgroundColor": "yellow"}}>
          கிழக்கு நோக்கி</span>விடவும்.
     </div>
    <div className="mydiv">
      <img src="assets/img/sama-deva-tarpanam.jpg" style={{"width": "90%"}} />
    </div>
     1. அக்நிஸ் 			த்ருப்யது<hr />
     2. ப்ரஹ்மா 			த்ருப்யது<hr />
     3. ஸோமஸ் 			த்ருப்யது<hr />
     4. சிவஸ் 				த்ருப்யது<hr />
     5. ப்ரஜாபதிஸ் 			த்ருப்யது<hr />
     6. ஸவிதா 			த்ருப்யது<hr />
     7. இந்த்ரஸ் 			த்ருப்யது<hr />
     8. ப்ருஹஸ்பதிஸ் 		த்ருப்யது<hr />
     9. துவஷ்டா 			த்ருப்யது<hr />
     10. விஷ்ணுஸ் 			த்ருப்யது<hr />
     11. யமஸ் 				த்ருப்யது<hr />
     12. வாயுஸ் 			த்ருப்யது<hr />
     13. ஆதித்யஸ் 			த்ருப்யது<hr />
     14. சந்த்ரமா 			த்ருப்யது<hr />
     15. நக்ஷத்ராணி 		த்ருப்யந்து<hr />
     16. ஸஹதேவதாபி: வஸவ:  த்ருப்யந்து<hr />
     17. ருத்ராஸ் 		த்ருப்யந்து <hr />
     18. ஆதித்யாஸ் 		த்ருப்யந்து<hr />
     19. ப்ருகவஸ் 		த்ருப்யந்து<hr />
     20. அங்கிரஸஸ் 		த்ருப்யந்து<hr />
     21. ஸாத்யாஸ் 		த்ருப்யந்து<hr />
     22. மருதஸ் 		த்ருப்யந்து<hr />
     23. விஸ்வேதேவா: 	த்ருப்யந்து<hr />
     24. ஸர்வே தேவா: 	த்ருப்யந்து<hr />
     25. வாக்ச்ச  		த்ருப்யது<hr />
     26. மநஸ்ச்ச  		த்ருப்யது<hr />
     27. ஆபஸ்ச்ச  		த்ருப்யது<hr />
     28. ஓஷதயஸ்ச்ச  	த்ருப்யது<hr />
     29. இந்த்ராக்நீ 		த்ருப்யேதாம்<hr />
     30. தாதா  			த்ருப்யது<hr />
     31. அர்யமா  		த்ருப்யது<hr />
     32. ஸார்த்தமாஸர்தவ:	த்ருப்யந்து<hr />
     33. திதி:  			த்ருப்யது<hr />
     34. அதிதி:  		த்ருப்யது<hr />
     35. இந்த்ராணி   	த்ருப்யது<hr />
     36. உமா  			த்ருப்யது<hr />
     37. ஸ்ரீஸ்ச்ச  		த்ருப்யது<hr />
     38. ஸர்வாஸ்ச்ச தேவபத்ந்ய: த்ருப்யந்து!<hr />
     39. ருத்ரஸ் 		த்ருப்யது<hr />
     40. ஸ்கந்தவிசாகௌ   த்ருப்யேதாம்<hr />
     41. விச்வகர்மா  		த்ருப்யது<hr />
     42. தர்சஸ்ச்ச  		த்ருப்யது<hr />
     43. பௌர்ணமாஸச்ச 	த்ருப்யது<hr />
     44. சாதுர்வேத்யம்  	த்ருப்யது<hr />
     45. சாதுர்ஹெளத்ரம் 	த்ருப்யது<hr />
     46. வைஹாரிகாஸ் 	த்ருப்யந்து<hr />
     47. பாகயக்ஞாஸ் 	த்ருப்யந்து<hr />
     48. ஸ்தாவர ஜங்கமே 	த்ருப்யேதாம்<hr />
     49. பர்வதாசிஷஸ் 	த்ருப்யந்து<hr />
     50. பவ்யஸ் 		த்ருப்யது<hr />
     51. நத்யஸ் 		த்ருப்யந்து<hr />
     52. ஸமுத்ரஸ் 		த்ருப்யது<hr />
     53. அபாம்பதிஸ் 		த்ருப்யது<hr />
     54. யஜமாநா: யேதேவாஸ்து  ஏகாதசகா:
     த்ரயஸ்ச்ச த்ரீணீச  சதா:
     த்ரயஸ்ச்ச த்ரீணீச ஸஹஸ்ரா: த்ருப்யந்து<hr />
     55. த்விபவித்ர்யா தேவா:  த்ருப்யந்தாம்<hr />
     56. ஏகபவித்ர்யா தேவா: மநுஷ்ய
     ப்ரப்ருதய: த்ருப்யந்து<hr />
     57.ஸங்கர்ஷண வாசுதேவெள த்ருப்யேதாம்<hr />
     58. தந்வந்த்ரிஸ் 		த்ருப்யது<hr />
     59. ஸாதுகாரா: 		த்ருப்யது<hr />
     60. உதரவைச்ரவண பூர்ணபத்ர
     மாணிபத்ரா:   	த்ருப்யந்து<hr />
     61. யாதுதாநா: 		த்ருப்யந்து<hr />
     62. யக்ஷாஸ் 		த்ருப்யந்து<hr />
     63. ரக்ஷாகும்ஸி  	த்ருப்யந்து<hr />
     64. இதர கணா: 		த்ருப்யந்து<hr />
     65. த்ரைகுண்யம் 	த்ருப்யது<hr />
     66. நாமாக்யாத உபஸர்கநிபாதா: த்ருப்யந்து<hr />
     67. தேவருஷய: 		த்ருப்யந்து<hr />
     68. மஹா வ்யா ;ருதய: த்ருப்யந்து<hr />
     69. ஸாவித்ரீ 		த்ருப்யது<hr />
     70. ருசஸ்			த்ருப்யந்து<hr />
     71. யஜூகும்ஷி 		த்ருப்யந்து<hr />
     72. ஸாமாநி 		த்ருப்யந்து<hr />
     73. காண்டாநி 		த்ருப்யந்து<hr />
     74. ஏஷாந்தைவதாநி   த்ருப்யந்து <hr />
     75 ப்ராயஸ்சித்தாநி 	த்ருப்யந்து<hr />
     76. சுக்ரியோபநிஷத: 	த்ருப்யந்து<hr />
     77. சோகீஸ் 		த்ருப்யது<hr />
     78. சுகஸ் 			த்ருப்யது<hr />
     79. சாகல்யஸ்		த்ருப்யது<hr />
     80.  பாஞ்சாலஸ் 	த்ருப்யது<hr />
    81. ருசாபிஸ் 		த்ருப்யது
    <hr className="new" />
    <div className="hint">(ருஷி தர்பணம்   பூணல் மாலை)
      <br />
      இரண்டு எருக்கு இலை மேல் இரு தர்பங்களை வைத்துக்கொண்டு
       அதில் அக்ஷதை சேர்த்துக்கொண்டு, ஒவ்வொரு தர்பணத்திற்கும்
       சிறிது சிறிதாக ஜலம் சேர்த்து <span style={{"backgroundColor": "yellow"}}>
         வடக்கு நோக்கி</span> விடவும்.
    </div>
    <div className="mydiv">
        <img src="assets/img/sama-rishi-tarpanam.jpg" style={{"width": "90%"}} />
      </div>
     82. வ்யாஸஸ்  		த்ருப்யது<hr />
     83. பாராசாயஸ் 	த்ருப்யது<hr />
     84. தாண்டீ 		த்ருப்யது<hr />
     85. குகீஸ் 		த்ருப்யது<hr />
     86. கௌசிகீ 		த்ருப்யது<hr />
     87. படபா 		த்ருப்யது<hr />
     88. ப்ராதிதேயீ 		த்ருப்யது<hr />
     89. மைத்ராயணீ 	த்ருப்யது<hr />
     90. தாக்ஷாயணீ 		த்ருப்யது<hr />
     91. ஸர்வாச்சார்யா: 	த்ருப்யந்து<hr />
     92. குலாச்சார்யா: 	த்ருப்யந்து<hr />
     93. குருகுலவாசிந: 	த்ருப்யந்து<hr />
     94. கந்யா 		த்ருப்யது<hr />
     95. ப்ரம்ஹச்சாரி 	த்ருப்யது<hr />
     96. ஆத்மார்த்தீ 		த்ருப்யது<hr />
     97. யாக்ஞ்யவல்க்ய: 	த்ருப்யது<hr />
     98. ராணாயநீ 		த்ருப்யது<hr />
     99. ஸாத்ய முக்ரீ 	த்ருப்யது<hr />
     100. துர்வாசா: 		த்ருப்யது<hr />
     101. பாகுரீ 		த்ருப்யது<hr />
     102. கௌருண்டீ 		த்ருப்யது<hr />
     103. கௌல்குலவீ 	த்ருப்யது<hr />
     104. பகவாந் ஒளபமந்யவ:	த்ருப்யது<hr />
     105. தாராளஸ் 		த்ருப்யது<hr />
     106. கார்கிஸாவர்ணீ 	த்ருப்யது<hr />
     107. வர்ஷகண்யச்ச 	த்ருப்யது<hr />
     108. குதுமிச்ச 		த்ருப்யது<hr />
     109. ஸாலிஹோத்ரச்ச 	த்ருப்யது<hr />
     110. ஜைமிநிச்ச 		த்ருப்யது<hr />
     111. சடி:			த்ருப்பயது<hr />
     112. பால்லபவி		த்ருப்யது<hr />
     113. காலபவி		த்ருப்யது<hr />
     114. தாண்ட்யஸ் 		த்ருப்யந்து<hr />
     115. வ்ருச்ச 		த்ருப்யது<hr />
     116. வ்ருஷாணகச்ச 	த்ருப்யது<hr />
     117. ருருகிச்ச 		த்ருப்யது<hr />
     118. அகஸ்த்யஸ்		த்ருப்யது<hr />
     119. பட்கசிரா: 		த்ருப்யது<hr />
     120. குஹூஸ்ச 		த்ருப்யது
     தசஇத்யேதே  ப்ரவசன  கர்தார:
     ஸ்வஸ்தி  குர்வந்து தர்பிதா:
     ஸ்வஸ்தி  குர்வந்து தர்பிதா: <hr className="new" />
    <div className="hint"> இனி தேவ தர்பணம் உபவீதி (பூணல் நேர்)
        <br />
        இரண்டு எருக்கு இலை மேல் இரு தர்பங்களை வைத்துக்கொண்டு
         அதில் அக்ஷதை சேர்த்துக்கொண்டு, ஒவ்வொரு தர்பணத்திற்கும்
         சிறிது சிறிதாக ஜலம் சேர்த்து <span style={{"backgroundColor": "yellow"}}>
           கிழக்கு நோக்கி</span> விடவும்.
    </div>
    <div className="mydiv">
        <img src="assets/img/sama-deva-tarpanam.jpg" style={{"width": "90%"}} />
      </div>
     121. அக்நிஸ் 			த்ருப்யது<hr />
     122.  ப்ரஹ்மா 			த்ருப்யது<hr />
     123.  தேவாஸ் 			த்ருப்யந்து<hr />
     124.  வேதாஸ் 			த்ருப்யந்து<hr />
     125.  ஓங்காரஸ் 			த்ருப்யது<hr />
     126.  ஸாவித்ரி 		த்ருப்யது<hr />
     127.  யக்ஞாஸ் 		த்ருப்யந்து<hr />
     128.  த்யாவா ப்ருத்வீ 	த்ருப்யேதாம்<hr />
     129. அஹோராத்ராணி 	த்ருப்யந்து<hr />
     130. ஸங்க்யாஸ் 		த்ருப்யந்து<hr />
     131. ஸமுத்ராஸ் 		த்ருப்யந்து<hr />
     132. க்ஷேத்ரௌஷதி  வநஸ்பதய: த்ருப்யந்து<hr />
     133.  கந்தர்வாஸ் 			த்ருப்யந்து<hr />
     134. அப்ஸரஸஸ் 			த்ருப்யந்து<hr />
     135.  நாகாஸ் 			த்ருப்யந்து<hr />
     136.  யக்ஷாஸ் 			த்ருப்யந்து <hr />
     137.  ரக்ஷாகும்ஸி 			த்ருப்யந்து
     பூதாகும்சைவ அநுமந்யந்தாம்<hr className="new" />
    <div className="hint">ருஷி தர்பணம் (பூணல் மாலை)
        <br />
        இரண்டு எருக்கு இலை மேல் இரு தர்பங்களை வைத்துக்கொண்டு
         அதில் அக்ஷதை சேர்த்துக்கொண்டு, ஒவ்வொரு தர்பணத்திற்கும்
         சிறிது சிறிதாக ஜலம் சேர்த்து <span style={{"backgroundColor": "yellow"}}>
           வடக்கு நோக்கி</span> விடவும்.
    </div>
    <div className="mydiv">
        <img src="assets/img/sama-rishi-tarpanam.jpg" style={{"width": "90%"}} />
      </div>
     138. ஸுமந்துஸ் 			த்ருப்யது<hr />
     139. ஜைமிநிஸ் 			த்ருபய்து<hr />
     140. விஸ்வாமித்ரஸ் 		த்ருப்யது<hr />
     141. வசிஷ்டஸ் 			த்ருப்யது<hr />
     142. பராசரஸ் 			த்ருப்யபது<hr />
     143. ஜாநந்துஸ் 			த்ருப்யது<hr />
     144. பாஹவஸ்			த்ருப்யது<hr />
     145. கௌதமஸ் 			த்ருப்யது<hr />
     146. சாகல்யஸ் 			த்ருப்யது<hr />
     147. பாப்ரவ்யஸ் 			த்ருப்யது<hr />
     148. மாண்டவ்யஸ் 			த்ருப்யது<hr />
     149. படபா 				த்ருப்யது<hr />
     150. ப்ராதிதேயீ 			த்ருப்யது
     யேச்சாந்யே ஆச்சார்யா:
     தேப்யஸ்ச்ச  ஸ்வதேதி
     தேப்யஸ்ச்ச  ஸ்வதேதி<hr className="new" />
     <div className="hint">இனி தேவ தர்பணம்  உபவீதி (பூணல் நேர்)
        <br />
        இரண்டு எருக்கு இலை மேல் இரு தர்பங்களை வைத்துக்கொண்டு
         அதில் அக்ஷதை சேர்த்துக்கொண்டு, ஒவ்வொரு தர்பணத்திற்கும்
         சிறிது சிறிதாக ஜலம் சேர்த்து <span style={{"backgroundColor": "yellow"}}>
           கிழக்கு நோக்கி</span> விடவும்.
     </div>
     <div className="mydiv">
        <img src="assets/img/sama-deva-tarpanam.jpg" style={{"width": "90%"}} />
      </div>
     151.  ஒம் நமோ ப்ரஹ்மணே த்ருப்திரஸ்து<hr />
     152.  ஓம் நமோ ப்ராஹ்மணேப்ய: த்ருப்திரஸ்து<hr />
     153.  ஓம் நமோ ஆச்சார்யேப்ய:  த்ருப்திரஸ்து<hr />
     154.  ஓம்  நமோ ருஷிப்ய: த்ருப்திரஸ்து<hr />
     155.  ஓம்  நமோ தேவேப்ய: த்ருப்திரஸ்து<hr />
     156.  ஓம் நமோ வேதேப்ய: த்ருப்திரஸ்து<hr />
     157.  ஓம் நமோ வாயவேச த்ருப்திரஸ்து<hr />
     158.  ஓம் நமோ  ம்ருத்யவேச த்ருப்திரஸ்து<hr />
     159.  ஓம் நமோ விஷ்ணவேச த்ருப்திரஸ்து<hr />
     160.  ஓம் நமோ வைச்ரவணாயச த்ருப்திரஸ்து<hr className="new" />
    <div className="hint">ருஷி  தர்பணம்  (பூணல் மாலை)
     (இனி வருபவற்றில் இறுதியில் ... புள்ளிகள்
     உள்ள இடத்தில் "உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து"
     என்பதை சேர்த்துக்கொள்ளவும்.)
     <br />
     இரண்டு எருக்கு இலை மேல் இரு தர்பங்களை வைத்துக்கொண்டு
      அதில் அக்ஷதை சேர்த்துக்கொண்டு, ஒவ்வொரு தர்பணத்திற்கும்
      சிறிது சிறிதாக ஜலம் சேர்த்து <span style={{"backgroundColor": "yellow"}}>
        வடக்கு நோக்கி</span> விடவும்.
    </div>
     <div className="mydiv">
        <img src="assets/img/sama-rishi-tarpanam.jpg" style={{"width": "90%"}} />
      </div>
      161. ஸர்வதத்தாது கார்க்யாது
      உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      162.ஸர்வதத்த: கார்க்ய: ருத்ரபூதே: த்ராஹ்யாயணே:உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      163.ருத்ரபூதி: த்ராஹ்யாயணி: த்ராதாது ஐஷுமாதது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      164.த்ராத: ஐஷுமத: நிகடாது பார்ணவல்கே: உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      165.நிகட: பார்ணவல்கி: கிரிசர்மண: காண்டேவித்தே:உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      166.கிரிசர்மா காண்டேவித்தி:
      ப்ரம்மவ்ருத்தே: சந்தோக மாஹகே: உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      167.ப்ரம்மவ்ருத்தி: சந்தோகமா கி: மித்ரவர்ச:
      ஸ்தைரகாயநாது .உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      168.மித்ரவர்ச்சா: ஸ்தைரகாயந:
      சுப்ரதீதாது ஒளலுந்த்யாது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      169.ஸுப்ரதீத: ஒளலுந்த்ய: ப்ருஹஸ்பதி
      குப்தாது சாயஸ்தே: உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      170. ப்ருஹஸ்பதிகுப்த: சாயஸ்தி:
      பவத்ராதாது சாயஸ்தே: உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      171.பவத்ராத: சாயஸ்தி: குஸ்துகாது
      சார்க்கராக்ஷாது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      172.குஸ்துக: சார்க்கராக்ஷ: ச்ரணவதத்தாது
      கௌஹலாது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      173.ச்ரவணதத்த: கௌஹல:  சுசாரதாது
      சாலங்காயநாது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      174.சுசாரத: சாலங்காயந: ஊர்ஜயத:
      ஒளபமந்யவாது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      175.ஊர்ஜயநு ஒளபமந்யவ: பாநுமத:
      ஒளபந்யவாது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      176.பாநுமாநு ஒளபமந்யவ:  ஆனந்தஜாது
      சாந்தநாயநாது    உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      177.ஆனந்தஜ: சாந்தநாயன:  சாம்பாது
        சார்க்கராக்ஷாது காம்போஜாச்ச ஒளபமந்யவாதுஉபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      178.சாம்ப: சார்க்கராக்ஷ: காம்போஜஸ்ச்ச
      ஒளபமந்யவ: மத்ரகாராது சௌங்காயநே: உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      179.மத்ரகார: சௌங்காயநி: ஸ்வாதே: 							ஒளஷ்ட்ராக்ஷே:உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      180.ஸ்வாதி: ஒளஷ்ட்ராஷ்டி: ஸுஸ்ரவஸ:
      வார்ஷகண்யாது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      181.சுஸ்ரவா: வார்ஷகண்ய: ப்ராதரந்நாது 						கௌஹலாது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      182.ப்ராதரஹ்ந: கௌஹல: கேதோ: வாஜ்யாதுஉபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      183.கேதுர்வாஜ்ய: மித்ரவிந்த்யாது கௌஹலாது  உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      184.மிந்த்ரவிந்த: கௌஹல: ஸுநீதாது காபடவாது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      185.ஸுநீத: காபடவ: ஸுதேமநஸ: 							சாண்டில்யாயநாதுஉபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      186.ஸுதேமநஸ: சாண்டில்யாயந: அகும்சோ:
      தாநஞ்ஜய்யாது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      187.அகும்சு: தாநஞ்ஜய்ய: அமாவாஸ்யாது
      சாண்டில்யாயநாது  ராதாஸ்ச்ச கௌதமாது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      188.ராத: கௌதம: காது: கௌதமாது பிது: உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      189.காதா கௌதம: ஸம்வர்கஜித: லாமகாயநாதுஉபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      190.ஸம்வர்க்கஜிது லாமகாயந: ஸாகதாஸாது 	பாடிதாயநாது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      191.ஸாகதாஸ:  பாடிதாயந: விசக்ஷணாது தாண்டியாது பிது: உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      192.விசக்ஷண:  தாண்டிய: கர்தபீமுகாது
      சாண்டில்யாயநாது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      193.கர்தபீமுக: சாண்டில்யாயந: உதரசாண்டில்யாது பிது:உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      194.உதரசாண்டில்ய: அதிதந்வநஸ்ச்ச
      சௌநகாது மஸகாஸ்ச்ச  கார்க்யாது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      195.மசக: கார்க்ய: ஸ்திரகாது கார்க்யாது  பிது: உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      196.ஸ்திரக: கார்க்ய: வாசிஷ்டாது சைகிதாநேயாது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      197.வாசிஷ்ட: சைகிதாநேய: வாசிஷ்டாது
      ஆரைஹண்யாது ராஜன்யாது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      198.வாசிஷ்ட: ஆரைஹண்ய: ராஜன்ய:
      ஸுமந்த்ராது பாப்ரவாது  கௌதமாது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      199.ஸுமந்த்ர: பாப்ரவ:  கௌதம:  ஸூஷாது
      வாந்ஹேயாது பாரத்வாஜாது      	உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      200.ஸூஷ: வாந்ஹேய: பாரத்வாஜ: அராலாது
      தார்த்தேயாது சௌநகாது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      201.அரால: தார்த்தேய:  சௌநக: த்ருதே:
      ஐந்த்ரோதாது சௌநகாது பிது:   	உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      202.த்ருதி: இந்த்ரோத: சௌநக:
      இந்த்ரோதாது சௌநகாது பிதுரேவ உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      203.இந்த்ரோத: சௌநக: வ்ருஷசுஷ்ணாது
      வாதாவதாது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      204.வ்ருஷசுஷ்ண: வாதாவத: நிகோதகாது
      பாயஜாத்யாது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      205.நிகோதக: பாயஜாத்ய: ப்ரதிதே:
      தேவதரதாது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      206.  ப்ரதிதி:  தேவதரத: தேவதரஸ:
      சாவஸாயநாது பிது: உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      207. தேவதரா: சாவஸாயந: சவஸ: பிதுரேவ உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      208.சவா: அக்நிபுவ: காச்யபாது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      209.அக்நிபூ: காச்யப:  இந்த்ரபுவ: காச்யபாதுஉபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      210.இந்த்ரபூ: காச்யப: மித்ரபுவ: காச்யபாதுஉபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      211.மித்ரபூ: காச்யப: விபண்டகாது காச்யபாது பிது:உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      212.விபண்டக: காச்யப: ருச்யச்ருங்காது
      காச்யபாது பிது:உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      213.ருச்யச்ருங்க: காச்யப:  கச்யபாது பிதுரேவ உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      214.கச்யப: அக்நே: உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து
      <hr className="new" />
    <div className="hint"> தேவதர்ப்பணம் உபவீதி  (பூணல் நேர்)
        <br />
        இரண்டு எருக்கு இலை மேல் இரு தர்பங்களை வைத்துக்கொண்டு
         அதில் அக்ஷதை சேர்த்துக்கொண்டு, ஒவ்வொரு தர்பணத்திற்கும்
         சிறிது சிறிதாக ஜலம் சேர்த்து <span style={{"backgroundColor": "yellow"}}>
           கிழக்கு நோக்கி</span> விடவும்.
    </div>
    <div className="mydiv">
        <img src="assets/img/sama-deva-tarpanam.jpg" style={{"width": "90%"}} />
      </div>
     215.அக்நி:  இந்த்ராது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
     216.இந்தர: வாயோ: உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
     217.வாயு: ம்ருத்யோ: உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
     218.ம்ருத்யு: ப்ரஜாபதே: உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
     219.ப்ரஜாபதி: ப்ரஹ்மண: உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
     220.ப்ரஹ்மா ஸ்வயம்பூ: தஸ்மை நம:
     தேப்யோ நம:
     <hr className="new" />
     <div className="hint">ருஷி தர்ப்பணம் நிவீதி (பூணல் மாலை)
        <br />
        இரண்டு எருக்கு இலை மேல் இரு தர்பங்களை வைத்துக்கொண்டு
         அதில் அக்ஷதை சேர்த்துக்கொண்டு, ஒவ்வொரு தர்பணத்திற்கும்
         சிறிது சிறிதாக ஜலம் சேர்த்து <span style={{"backgroundColor": "yellow"}}>
           வடக்கு நோக்கி</span> விடவும்.
     </div>
     <div className="mydiv">
        <img src="assets/img/sama-rishi-tarpanam.jpg" style={{"width": "90%"}} />
      </div>
    
      221.அர்யமபூதே: காலபவாது   .உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      222.அர்யமபூதி:  காலபவ:  பத்ரசர்மண:  	கௌசிகாது	  	    உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      223.பத்ரசர்மா கௌசிக:  புஷ்யயசஸ: 	ஒளதவ்ஜே:  .உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      224.புஷ்யயசஸ: ஒளதவ்ரஜி: ஸங்கராது	கௌதமாது     உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      225.ஸங்சர: கௌதம: அர்மராதாச்ச உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      கோபிலாது பூஷமித்ராச்ச கோபிலாது   உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      226.பூஷமித்ர: கோபில: அஸ்வமித்ராது  	 						கோபிலாது  	   உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      227.அஸ்வமித்ர: கோபில: வருணமித்ராது 						கோபிலாது    உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      228.வருணமித்ர: கோபில:  மூலமித்ராது 							கோபிலாது    உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      229.மூலமித்ர:  கோபில: வத்ஸமித்ராது  	 						கோபிலாது .உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      230.வத்ஸமித்ர: கோபில: 					கொளல்குலவீபுத்ராது கோபிலாது   உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      231.கௌல்குலவீபுத்ர: கோபில:
      ப்ருஹத்வஸோ: பிது: உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      232.    ப்ருஹத்வஸு:  கோபில: 							கோபிலாதேவ   உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      233.கோபில: ராதாச்ச கௌதமாது    உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      234.ராத: கௌதம: காது: கௌதமாது பிது:உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      235.காதா கௌதம: ஸம்வர்கஜித:
      லாமகாயநாது     		உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      236.ஸம்வர்க்கஜிது லாமகாயந: ஸாகதாஸாது 					பாடிதாயநாது    உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      237.ஸாகதாஸ:  பாடிதாயந: விசக்ஷணாது 					தாண்டியாது   உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      238.விசக்ஷண:  தாண்டிய: கர்தபீமுகாது 						சாண்டில்யாயநாது   உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      239.கர்தபீமுக:  சாண்டில்யாயந: 						உதரசாண்டில்யாது பிது:     உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      240.உதரசாண்டில்ய: அதிதந்வநஸ்ச்ச உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      சௌநகாது  மஸகாஸ்ச்ச கார்க்யாது   உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      241.மசக: கார்க்ய: ஸ்திரகாது கார்க்யாது பிது: . உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      242.ஸ்திரக: கார்க்ய: வாசிஷ்டாது 							சைகிதாநேயாது .   	உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      243.வாசிஷ்ட: சைகிதாநேய: வாசிஷ்டாது
      ஆரைஹண்யாது  ராஜன்யாது	   உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      244.வாசிஷ்ட: ஆரைஹண்ய: ராஜன்ய:
      ஸுமந்த்ராது  பாப்ரவாது  கௌதமாது    உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      245.ஸுமந்த்ர: பாப்ரவ: கௌதம: ஸூஷாது
      வாந்ஹேயாது  பாரத்வாஜாது	   உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      246.ஸூஷ: வாந்ஹேய: பாரத்வாஜ: அராலாது
      தார்த்தேயாது  சௌநகாது    உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      247.அரால: தார்த்தேய:  சௌநக: த்ருதே:
      ஐந்த்ரோதாது  சௌநகாது பிது:    உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      248.த்ருதி: இந்த்ரோத: சௌநக:
      ஐந்த்ரோதாது சௌநகாது  பிதுரேவ    உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      249.இந்த்ரோத: சௌநக: வ்ருஷசுஷ்ணாது 						வாதாவதாது .	உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      250.வ்ருஷசுஷ்ண: வாதாவத: நிகோதகாது 					பாயஜாத்யாது .உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      251.நிகோதக: பாயஜாத்ய: ப்ரதிதே: 						தேவதரதாது .உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      252.ப்ரதிதி: தேவதரத: தேவதரஸ:
      சாவஸாயநாது பிது: . உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      253.  தேவதரா: சாவஸாயந: சவஸ: பிதுரேவ                           	உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      254.  சவா:  அக்நிபுவ: காச்யபாது       உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      255.அக்நிபூ:காச்யப: இந்த்ரபுவ: காச்யபாது    உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      256.இந்த்ரபூ: காச்யப: மித்ரபுவ: காச்யபாது .உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      257.மித்ரபூ: காச்யப: விபண்டகாது
      காச்யபாது பிது:   உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      258.விபண்டக: காச்யப: ருச்யச்ருங்காது 						காச்யபாது பிது:   உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
      259.ருச்யச்ருங்க: காச்யப:
      கச்யபாது பிதுரேவ உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
    
     260.கச்யப: அக்நே: உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து
     <hr className="new" />
     <div className="hint">தேவதர்ப்பணம் உபவீதி  (பூணல் நேர்)
        <br />
        இரண்டு எருக்கு இலை மேல் இரு தர்பங்களை வைத்துக்கொண்டு
         அதில் அக்ஷதை சேர்த்துக்கொண்டு, ஒவ்வொரு தர்பணத்திற்கும்
         சிறிது சிறிதாக ஜலம் சேர்த்து <span style={{"backgroundColor": "yellow"}}>
           கிழக்கு நோக்கி</span> விடவும்.
     </div>
     <div className="mydiv">
        <img src="assets/img/sama-deva-tarpanam.jpg" style={{"width": "90%"}} />
      </div>
     261.அக்நி:  இந்த்ராது உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
     262.இந்தர: வாயோ: உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
     263.வாயு: ம்ருத்யோ: உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
     264.ம்ருத்யு: ப்ரஜாபதே: உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
     265.ப்ரஜாபதி: ப்ரஹ்மண: உபஜாயத தஸ்மை நம: த்ருப்திரஸ்து<hr />
     266.ப்ரஹ்மா ஸ்வயம்பூ:  தஸ்மை நம: தேப்யோ நம:
     <hr className="new" />
    
    <div className="hint">தகப்பனார் இல்லாதவர்கள் மட்டும்
      இரண்டுபில் பவித்திரத்தை அவிழ்த்து அடையாளமாக
      வைத்துவிட்டு ஒரு 3 பில் பவித்திரத்தைப் போட்டுக்கொண்டு
      பூணலை ப்ராசீனாவீதமாக போட்டுக்கொண்டு, 3 எருக்கு இலை மேல்
      3 தர்பங்களை வைத்துக்கொண்டு எள் சேர்த்துக்கொண்டு
      பின் வரும் தர்பணங்கசச் செய்யவும்.</div>
      <div className="mydiv">
          <img src="assets/img/sama-pitru-tarpanam.jpg" style={{"width": "90%"}} />
        </div>
    1.பித்ரூணாம்  த்ருப்திரஸ்து     	(3 முறை)<hr />
     2.பிதாமஹாணாம் த்ருப்திரஸ்து 	(3 முறை)<hr />
     3.ப்ரபிதாமஹாணாம் த்ருப்திரஸ்து	(3 முறை)<hr />
     4.மாத்ரூணாம் த்ருப்திரஸ்து   	(3 முறை)<hr />
     5.பிதாமஹாணாம் த்ருப்திரஸ்து 	(3 முறை)<hr />
     6.ப்ரமாதாமஹாணாம் த்ருப்திரஸ்து	(3 முறை)<hr />
     7.ஆச்சார்யாணாம்  த்ருப்திரஸ்து 	(3 முறை)<hr />
     8.ப்ராச்சார்யாணாம்  த்ருப்திரஸ்து 	(3 முறை)<hr />
     9.ஸகும்ஹிதாகார பதகார ஸூத்ரகார
     ப்ராஹ்மணகாராணாம்  த்ருப்திரஸ்து 	(3 முறை)<hr />
     10.ப்ராஹ்மணாநாம் அநபத்யாநாம்  த்ருப்திரஸ்து(3 முறை)<hr />
     11.ப்ராஹ்மணீநாம் ஏகபத்நீநாம் அநபத்யாநாம் த்ருப்திரஸ்து 	(3 முறை)<hr />
     12.ஸர்வேஷாஞ்ச ப்ரஹ்மசாரிணாம் த்ருப்திரஸ்து  	(3 முறை)<hr />
     <hr className="new" />
    
    
    <hr />{/*Sama Veda Content End*/}
    <div>
        <img src="assets/img/pavithram-in-ear.jpg" className="img2" />
      <div className="hint">என்று தர்பித்தபின் பூநூலை உபவீதமாகப்
        போட்டுக்கொண்டு பவித்ரம் காதில் வைத்து
        ஆசமனம் பண்ணவேண்டியது.</div>
        </div>
        <div className="clear"></div>
        <hr />
        <div>
            <img src="assets/img/achamanam.gif" />
          </div>
    
          <div className="head2">யஜ்ஞோபவீத தாரண ஸங்கல்பம்: </div>
          <hr />
            <div className="prayogam">மம ச்ரௌத ச்மார்த்த விதி விஹித நித்ய கர்மாநுஷ்டாந யோக்யதா ஸித்தியர்த்தம் ப்ரஹ்ம தேஜ: அபிவ்ருத்தியர்த்தம் யஜ்ஞோபவீத தாரணம்
              கரிஷ்யே. </div>
          <div className="sans">
              मम श्रौतस्मार्त वितिविहित न्त्यिकर्म अनुष्टान योग्यता सिध्यर्थं ब्रह्मतेज:
              अभिवृद्धयर्थं यज्ञोपवीत धारणं करिष्ये।
          </div>
    
          <hr />
            <div className="head2">யஜ்ஞோபவீத தாரண ந்யாஸம்:</div>
          <hr />
          <div>
              <img src="assets/img/Nyaasam1.jpg" className="img2" />
    
              <div className="hint">தலையைத் தொட்டு :</div>
              <div className="prayogam">யஜ்ஞோபவீத தாரண மந்த்ரஸ்ய ப்ரும்மா ருஷி:</div>
              <div className="sans">यज्ञोपवीत धारण मन्त्रस्य ब्रह्मा ऋषि:</div>
            </div>
    
            <div className="clear"></div><hr />
    
            <div>
              <img src="assets/img/Nyaasam2.jpg" className="img2" />
    
              <div className="hint">மூக்கைத் தொட்டு :-</div>
              <div className="prayogam">‘அநுஷ்டுப் சந்த:’</div>
              <div className="sans">अनुष्टुप् छन्द:</div>
    
            </div>
            <div className="clear"></div><hr />
    
    
    
            <div>
              <img src="assets/img/Nyaasam3.jpg" className="img2" />
              <div className="hint">மார்பைத் தொட்டு :-</div>
              <div className="prayogam">‘த்ரயீ வித்யா தேவதா’</div>
              <div className="sans">त्रयीविद्या देवता</div>
    
            </div>
            <hr />
    
            <div>
              <img src="assets/img/Nyaasam4.jpg" className="img2" />
    
              <div className="hint">இரு கைகளையும் உட்புறமாகத் திருப்பி:</div>
              <div className="prayogam"> ‘யஜ்ஞோபவீத தாரணே விநியோக:’</div>
              <div className="sans">यज्ञोपवीत धारणे विनियोग:</div>
            </div>
           <div className="head2">யஞ்ஞோபவீத தாரணம் </div>
          <hr />
          <img src="assets/img/Poonal-BrahmaMudichu.jpg" />
          <hr />
            <div>
                <img src="assets/img/poonal-position.jpg" className="img2" />
    
                <div className="hint">(பூணலில் ப்ரம்ம முடிச்சின் பசுமுகம் போன்ற இரண்டு
                  நுனிகளுடன் கூடிய பாகம் கட்டைவிரலை பார்த்திருக்கும்படி வலது கையில் வைத்து,
              இடது கையால் பூணலின் கீழ்ப் பாகத்தின் உள்ளே வைத்து
              தளர்வின்றி பிடித்துக்கொண்டு மந்திரம் முடிந்தவுடன் தலையில் மாட்டி வலதுகை
              உள்ளே நுழைத்து இடது கையை வெளியே எடுத்துவிடவும்) </div>
          </div>
          <div className="clear"></div>
          <hr />
          <div>
              <img src="assets/img/insert-poonal.jpg" className="img2" />
    
            <div className="prayogam">யஜ்ஞோபவீதம் பரமம் பவித்ரம் ப்ரஜாபதே:
              யத்ஸஹஜம் புரஸ்தாது ஆயுஷ்யம் அக்ரியம் ப்ரதிமுஞ்ச சுப்ரம்
              யஜ்ஞோபவீதம் பலமஸ்து தேஜ: </div>
          </div>
          <div className="clear"></div>
          <div className="sans">
              यज्ञोपवीतम् परमं पवित्रं प्रजापते: यत्सहजं पुरस्तात् आयुष्यं
              अग्रियं प्रतिमञ्चशुभ्रं यज्ञोपवीतं बलमस्तु तेज:
          </div>
    
            <div className="hint"> என்று சொல்லி போட்டுக்கொள்ளவேண்டியது.</div>
            <div className="hint"> (என்று சங்கல்பித்து) இடுக்கு தர்பம் இருந்தால் அதை
              வடக்கே (இடது புறம்) சேர்க்கவும். </div>
              <div className="svk2">Yajgnopaveeta-Sankalpam - Audio </div>
            <audio controls>
            <source src="https://www.brahminsnet.com/upakarma/audio/17-yagnopaveethasankalpam.ogg" type="audio/ogg" />
              <source src="https://www.brahminsnet.com/upakarma/audio/mp4/17-yagnopaveethasankalpam.mp4" type="audio/mp4" />
          Your browser does not support the audio element.
          </audio>
            <hr />
            <div>
                <img src="assets/img/pavithram-in-ear.jpg" className="img2" />
                <div className="hint">(கல்யாணமானவர்கள் மட்டும் 2வது பூணலுக்கு
                   பவித்ரம் காதில் வைத்து
               ஆசமனம் பண்ணி பின் பவித்ரம்
              போட்டு ப்ராணாயமம்)</div>
              </div>
              <div className="clear"></div>
          <hr />
          <div>
          <img src="assets/img/praanaayaamam.gif" />
          </div>
    
          <hr />
            <div><img src="assets/img/sankalpam.jpg" className="img2" />
            <div className="prayogam">ஸ்ரீ-ம் க்ருஹஸ்த ஆச்ரமார்த்தம் த்விதீய யஜ்ஞோபவீத
               தாரணம் கரிஷ்யே. </div>
               <div className="sans">
                  ग्रहस्त आश्रमार्थं िद्वतीय यज्ञोपवीत धारणं करिष्ये।
               </div>
               </div>
          <hr />
          <div>
              <img src="assets/img/poonal-position.jpg" className="img2" />
    
              <div className="hint">(பூணலில் ப்ரம்ம முடிச்சின் பசுமுகம் போன்ற இரண்டு
                நுனிகளுடன் கூடிய பாகம் கட்டைவிரலை பார்த்திருக்கும்படி வலது கையில் வைத்து,
            இடது கையால் பூணலின் கீழ்ப் பாகத்தின் உள்ளே வைத்து
            தளர்வின்றி பிடித்துக்கொண்டு மந்திரம் முடிந்தவுடன் தலையில் மாட்டி வலதுகை
            உள்ளே நுழைத்து இடது கையை வெளியே எடுத்துவிடவும்) </div>
          </div>
          <div className="clear"></div>
          <hr />
          <div>
            <img src="assets/img/insert-poonal.jpg" className="img2" />
    
          <div className="prayogam">யஜ்ஞோபவீதம் பரமம் பவித்ரம் ப்ரஜாபதே:
            யத்ஸஹஜம் புரஸ்தாது ஆயுஷ்யம் அக்ரியம் ப்ரதிமுஞ்ச சுப்ரம்
            யஜ்ஞோபவீதம் பலமஸ்து தேஜ: </div>
          </div>
          <div className="clear"></div>
          <div className="sans">
            यज्ञोपवीतम् परमं पवित्रं प्रजापते: यत्सहजं पुरस्तात् आयुष्यं
            अग्रियं प्रतिमञ्चशुभ्रं यज्ञोपवीतं बलमस्तु तेज:
          </div>
    
          <div className="hint"> என்று சொல்லி போட்டுக்கொள்ளவேண்டியது.</div>
          <div className="hint"> (என்று சங்கல்பித்து) இடுக்கு தர்பம் இருந்தால் அதை
            வடக்கே (இடது புறம்) சேர்க்கவும். </div>
            <div className="svk2">Gruhasta-2nd-Poonal - Audio </div>
          <audio controls>
          <source src="https://www.brahminsnet.com/upakarma/audio/18-2ndpoonal.ogg" type="audio/ogg" />
            <source src="https://www.brahminsnet.com/upakarma/audio/mp4/18-2ndpoonal.mp4" type="audio/mp4" />
          Your browser does not support the audio element.
          </audio>
          <hr />
             <div className="hint"> பின் க்ருஹஸ்தாள் ப்ருஹ்மச்சாரி அனைவரும் </div>
            <div className="prayogam">"உபவீதம் பின்னதந்தும் ஜீர்ணம் கஸ்மலதூஷிதம்
              விஸ்ருஜாமி ஜலேப்ரஹ்மண்ணு வர்ச்ச: தீர்காயு: அஸ்துமே"</div>
              <div className="sans">
                  उपवीतं भिन्नतन्तुं जीर्णं कश्मलदूषितम्।<br />
                  विसृजामि जले ब्रह्मन् वर्च: दीर्घायु: अस्तु मे।।
              </div>
              <div className="svk2">Remove Old Poonal - Audio </div>
              <audio controls>
              <source src="https://www.brahminsnet.com/upakarma/audio/19-removepoonal.ogg" type="audio/ogg" />
                <source src="https://www.brahminsnet.com/upakarma/audio/mp4/19-removepoonal.mp4" type="audio/mp4" />
              Your browser does not support the audio element.
              </audio>
          <hr />
    
          <div>
              <img src="assets/img/pavithram-in-ear.jpg" className="img2" />
            <div className="hint"> என்று சொல்லி பழைய பூணலை எடுத்துவிட்டு பவித்ரம்
              காதில் வைத்து ஆசமனம் பண்ணவும். </div>
              </div>
              <img src="assets/img/achamanam.gif" />
          <hr />
          <h2>ப்ரஹ்மசாரி-மேகலா, அஜின, தண்ட தாரண மந்த்ங்கள்</h2>
     மேகலை அணிய:-<br />
     இயம் துருக்தாத் பரிபாதமாந வர்ணம் பவித்ரம் புநதீந: ஆகாத் |
     ப்ராணா அபாநாப்யாம் பலமாஹரந்தி ஸ்வஸா தேவீ: ஸுபகா மேகலா இயம் |
     ருதஸ்ய கோப்த்ரீ தபஸ: பரஸ்வீ க்நதீரக்ஷ: ஸஹமாநா அராதீ: |
     ஸாமா ஸமந்தம் அபிபர்யேஹி  பத்ரே தர்த்தாரஸ்தே மேகலே மாரிஷாமா ||<br />
     <div className="hint">ஓம் என்று சொல்லி அஜினத்தை பூணலில் கட்டிக்கொள்ளவும்.
     <br />
     தண்டம் அல்லது ஒரு ஸமித் எடுத்துக்கொள்ள:-</div>
    
    ஸுஸ்ரவ: ஸுஸ்ரவஸம் மா குரு, யதாத்வம் ஸுஸ்ரவ: ஸுஸ்ரவா: தேவேஷு ஏவமஹம்
    ஸுஸ்ரவ: ஸுஸ்ரவா: ப்ராஹ்மணேஷு பூயாஸம்.
    <hr />
    
      <div className="head2">வேதாரம்பம்</div>
      <div>
          <img src="assets/img/Sankalpam.jpg" className="img2" />
          <div className="hint"> ஒரு சுத்தமான இடத்தில்,
        கிழக்குமுகமாக அமர்ந்து பவித்ரம் போட்டுக்கொண்டு
        வலது தொடையில் இடதுகைமேல் வலது கைவைத்து
      </div>
      <div className="prayogam">"ப்ரோஷ்டபத்யாம் ஹஸ்தருக்ஷே,
        அத்யாய உபாகர்மணி வேதாரம்பம் கரிஷ்யே"</div>
      <div className="sans">श्री ...म्। प्रोष्ठपद्यां हस्तर्क्षे अध्याय उपाकर्मणि वेदारंभम् करिष्ये ।।
        </div>
      <div className="hint">என்று ஸங்கல்பம் செய்து கொண்டு
        கீழே உள்ள வேத மந்திரங்களை
        (தெரிந்தால் ஸ்வரத்துடன்) ஜபிக்கவும்.</div>
    </div>
    <div className="clear"></div>
    
      <div className="prayogam">
        வித்யுதஸி வித்யமே பாப்மானம் ருதாத் ஸத்யமுபைமி |<hr />
        <div className="hint">
          சொல்லவேண்டிய சில ஸாமங்கள்<br />
        காயத்ரி ஸாமம்   |<hr />
        வ்யாஹ்ருதி ஸாமம்  |<hr />
        ஸோமம் ராஜாநம்   |<hr />
        அக்ந ஆயாஹி வீதயே  |<hr />
        தத்வோ காய   |<hr />
        உச்சாதே  </div>
        மஹன்மேவோச: பர்கோமேவோச: ஓம் |<hr />
        ஸ்தோமேயுஜ்யதே ஸத்ரியேப்யோ ஹவிர்ப்ய: ஓம் |<hr />
      ப்ரஜாபதிர்வா இதமேக ஆஸீத் ஓம் |<hr />
      த்ரிவ்ருத் பஹிஷ்பவமானம் பஞ்சதசான்யாஜ்யானி ஓம் |<hr />
      அதிராத்ர: ப்ருஷ்டஷ்ஷடஹ: ஓம் |<hr />
      ப்ரம்ஹ ச வா இதமக்ரே ஸுப்ரஹ்ம சாஸ்தாம் ஓம் |<hr />
      ப்ரஹ்ம ஹ வா இதமக்ரே ஆஸீத் ஓம் |<hr />
      அதகல்வயம் ஆர்ஷப்ரதேசோபவதி ஓம் |<hr />
      அக்னிரிந்த்ர: ப்ரஜாபதி: ஓம் |<hr />
      தேவஸவித: ப்ரஸுவ யஜ்ஞம் ஓம் |<hr />
      ஓமித்யேததக்ஷரமுத்கீதமுபாஸீத ஓம் |<hr />
      அஸௌ வா ஆதித்யோதேவமது ஓம் |<hr />
      யோஹவைஜ்யேஷ்டஞ்சச்ரேஷ்டஞ்ச வேத ஓம் |<hr />
      அதாத: ஸம்ஹிதோபநிஷதோ வ்யாக்யாஸ்யாம: ஓம் |<hr />
      நமோ ப்ரஹ்மணே நமோ ப்ராஹ்மணேப்ய: ஓம் |<hr />
      அதாதோ வித்யவ்யபதேசே ஓம் |<hr />
      அதாத: சந்தஸாம் விசயம் வ்யாக்யாஸ்யாம: ஓம் |<hr />
      அதாத: ஸ்தோமான் வ்யாக்யாஸ்யாம: ஓம் |<hr />
      க்லுப்தோ ஜ்யோதிஷ்டோமோ அதிராத்ரோஷோடசிக: ஓம் |<hr />
      அதஸம்பத்ஸித்தி ரநாதேசே ஓம் |<hr />
      அதாத: ப்ரதிஹாரஸ்ய ஓம் |<hr />
      க்ராமகாமஸ்ய க்லுப்தோஜ்யோதிஷ்டோம: ஓம் |<hr />
      க்லுப்தோ ஜ்யோதிஷ்டோமே அதிராத்ர ப்ரதிராஷ்ட்ரம் ச ஓம் |<hr />
      ஓம் அக்ன ஆயானுதாத்தம் ஓம் |<hr />
      அக்நே ஜோதூதூ ஓம் |<hr />
      ஆமனபௌடீ ஓம் |<hr />
      அத்தாலவ்யாமாஇ யத்வருத்தம் ஓம் |<hr />
      அக்னிமீளே புரோஹிதம் ஓம் |<hr />
      இஷேத்வோர்ஜேத்வா ஓம் |<hr />
      சந்நோதேவீரபிஷ்டயே ஓம் |<hr />
      அ இ உண், ரு ளு க், ஏ ஓங், ஐ ஔ ச் ஓம் |<hr />
      கீர்ணச்ரேய:  ஓம் |<hr />
      ஆத்யம் புருஷமீசானம் ஓம் |<hr />
      மனுமேகாக்ர மாஸீனம் ஓம் |<hr />
      தப:ஸ்வாத்யாய நிரதம் ஓம் |<hr />
      வேதோதர்ம மூலம் ஓம் |<hr />
      வேதோ அகில தர்ம மூலம் ஓம் |<hr />
      அதாதோ தர்மஜிஜ்ஞாஸா ஓம் |<hr />
      அதாதோ ப்ரஹ்மஜிஜ்ஞாஸா ஓம் |<hr />
      வ்ருஷ்டிரஸி வ்ருச்சமே பாப்மானம் ருதாத் ஸத்யமுபாகாம் ஓம் |<hr />
      </div>
      <div className="sans">
          विद्युदसि विद्यमे पाप्मानं ऋतात् सत्यमुपैमि ।।<hr />
          हरि: ॐ। <hr />
          महन्मेवोच: भगोमेवोच: ओम्।<hr />
          स्तोमो युज्यते सत्रियोभ्यो हविर्भ्य: ओम्।<hr />
          प्रजापतिर्वा इदमेक आसीत् ओम्।<hr />
          तृवृत् बहिष्पवमानं पञ्चदश अन्याज्यानि। ओम्।<hr />
          अतिरात्र: पृष्टष्षडह:। ओम्।<hr />
          ब्रह्म च वा इदमग्रे सुब्रह्म चास्ताम्। ओम्।<hr />
          ब्रह्महवा इदमग्र आसीत् ।  ओम्।<hr />
          अथ खल्वयम् आर्षप्रदेश: भवति।  ओम्।<hr />
          अग्रिरन्द्र: प्रजापति:।  ओम्।<hr />
          देवसवित: प्रसुव यज्ञम्।।  ओम्।<hr />
          ओमित्येतत् अक्षरम् उद्गाीथमुपासीत।  ओम्।<hr />
          असौ वा ाादित्यो देव मधु ।।  ओम्।<hr />
          यो ह वै ज्येष्ठं च श्रेष्ठं च वेद।  ओम्।<hr />
          अथात: संहितोपनिषदो व्याख्यास्याम:।  ओम्।<hr />
          नमो ब्रह्मणे नमो ब्रह्मणेभ्य:।  ओम्।<hr />
          अथातो विद्ध्यव्यपदेशे।  ओम्।<hr />
          अथातश्छन्दसां विचयं व्याख्यास्याम:।  ओम्।<hr />
          अथात: स्तोमान् व्याख्यास्याम:।  ओम्।<hr />
          क्लुप्तो ज्योतिष्टोमोऽति रात्रोऽषोडशिक:।  ओम्।
          <br />
          अथ संपत्सििद्धरनादेशे। ओम्।<hr />
    आथात: प्रतिहारस्य।  ओम्।<hr />
    ग्रामकामस्य क्लुप्तो ज्योत्ष्टोिम:।  ओम्।<hr />
    क्लुप्तो ज्योत्ष्ठोिमे अतिरात्रप्रतिराष्ट्रं च।  ओम्।<hr />
    अग्न आयानुदात्तम।  ओम्।<hr />
    अग्नेझोतूतू।  ओम्।<hr />
    अथ तालव्यामाइ यद्वृद्धम्।  ओम्।<hr />
    अग्निमीले पुरोहितम्।   ओम्।<hr />
    इषेत्वोर्जेत्वा।   ओम्।<hr />
    शन्नोदेवीरभिष्टये ।   ओम्।<hr />
    अइउण्। ऋलृक्। एओङ् ऐओच्।   ओम्।<hr />
    गीर्णश्रेय: ।   ओम्। आद्यं पुरुषमीशानम्।   ओम्।<hr />
    मनुमेकाग्रमासीनम्।   ओम्।<hr />
    तप: स्वाध्याय निरतम।   ओम्।<hr />
    वेदो धर्ममूलम्।   ओम्।<hr />
    वेदोऽखिलो धर्ममूलम्।   ओम्।<hr />
    अथातो धर्मजिज्ञासा।   ओम्।<hr />
    अथातो ब्रह्मजिज्ञासा।   ओम्।<hr />
    वृष्टिरसि वरश्च मे पाप्मानमृतात् सत्यमुपागाम्।।
    
    
        </div>
    
    <hr />
      <div className="mydiv">வடகலையார்:
      <div className="prayogam">பகவாநேவ ...ஸ்வசேஷ பூதமிதம் அத்யாய
         உபாகர்மாக்யம் கர்ம ஸ்வஸ்மை ஸ்வப்ரீதயே
         பகவாந் ஸ்வயமேவ காரிதவாந்.</div>
      <div className="hint"> என்று ஸாத்வீக த்யாகம் சொல்லவேண்டியது.</div>
      </div>
    <hr />
    
              <img src="assets/img/shastanga-namaskaram.jpg" className="img1" />
    
              <div className="hint">  எழுந்திருந்து ஸேவித்து </div>
              <div className="clear"></div><hr />
            <img src="assets/img/abhivathi.jpg" className="img1" />
    
            <div className="hint">
              அபிவாதனம் பண்ணவேண்டியது.
        <br />பவித்ரம் பிரித்துப்போட்டு ஆசமனம் பண்ணறது. </div>
        <div className="clear"></div><hr />
    
    
    
    
    
    <div>
      <img src="assets/img/kaikoopu.jpg" className="img2" />
      <div className="hint">கையைக் கூப்பிக்கொண்டு சொல்லவும்</div>
    </div>
    <div className="clear"></div><hr />
    
        <div className="svk">
          அனைவரும் சொல்லலாம்.
        </div>
    <div className="prayogam">
      “காயேன வாசா மனஸா இந்த்ரியைர்வா புத்யா ஆத்மனாவா ப்ரஹ்ருதே: ச்வபாவாது கரோமி
        யத்யது ஸகலம் பரஸ்மை ஸ்ரீமன்நாராயணாயேதி ஸமர்பயாமி"
           .” ஸர்வம் ஸ்ரீக்ருஷ்ணார்ப்பணமஸ்து. அச்யுதப் ப்ரீயதாம்.
    </div>
    <div className="sans">
      कायेन वाचा मनसेन्द्रियैर्वा ।
      <br /> बुद्ध्यात्मना वा प्रकृतिस्वभावात् ।
      <br /> करोमि यद्यत्सकलं परस्मै ।
      <br /> नारायणयेति समर्पयामि ॥
    </div>
    <hr />
    <div className="hint"> பொதுவான இடத்தில் சென்று உபாகர்மா முடித்து
        ஆத்துக்கு வருபவர்களுக்கு ஆரத்தி எடுப்பது வழக்கம்.
        <br />
        <hr />
        இத்துடன் ஆவணியவிட்டம் முற்றுப்பெற்றது.
        </div>
    <hr />
    <div className="svk">பெருமாள் ஸேவித்து, பெரியவாளையும் ஸேவிக்கறது.</div>
      <div className="item"> மனம் நிறைந்த வாழ்த்துக்கள், குடும்பத்தாருடன், நோயற்ற வாழ்வு, குறைவற்ற செல்வம்,
      நீண்ட ஆயுளுடன், நிம்மதியாக வாழ எம்பெருமான் அருள்புரிய, ஆசீர்வாதங்களுடன்
      அல்லது வாழ்த்துக்களுடன் - வாத்யார்!
      <br />
      தாஸன்,<br />
      Dr.NVS </div>
    <hr />
    </div>
    <div className="tab-section my-8">
<h2 className="text-2xl font-bold mb-4">English</h2>
      <div className="svk">Achamanam</div>
  
  <hr />
  <div>
    <img src="assets/img/new-achamanam.gif" />
  </div>
  <div className="hint">Achamanam and Praanayaamams are frequent
  actions done several times in any vaideeka karma. So,kindly use the below
  instructions and bring it in practice doing without any guide.
    </div>
    <hr />
  <div className="sans">
    ओं अच्युताय नम:। ओं अनन्ताय नम:। <br />
    ओं गोविन्दााय नम:।<br />
    <div className="grid">
      <div className="flex flex-row flex-wrap">
        <div className="sans">ओं केशवाय नम:। </div>
        <div className="sans">नारायणाय नम:।</div>
      </div>
      <div className="flex flex-row flex-wrap">
        <div className="sans">माधवाय नम:।</div>
        <div className="sans">गोविन्दाय नम:।</div>
      </div>
      <div className="flex flex-row flex-wrap">
        <div className="sans">विष्णवे नम:। </div>
        <div className="sans">मधुसूदनाय नम:।
         </div>
      </div>
      <div className="flex flex-row flex-wrap">
        <div className="sans"> त्रिविक्रमाय नम:। </div>
        <div className="sans">वामनाय नम:।
          </div>
      </div>
      <div className="flex flex-row flex-wrap">
        <div className="sans">श्रीधराय नम:। </div>
        <div className="sans">हृषीकेशाय नम:।
          </div>
      </div>
      <div className="flex flex-row flex-wrap">
        <div className="sans">पद्मनाभाय नम:। </div>
        <div className="sans">दामोदराय नम:।</div>
      </div>
    </div>
     </div>
  <hr />
  <div>
      <img src="assets/img/Praanaayaamam1.jpg" className="img2" />

      <div className="hint">Sit facing East, insert two short dharbhams as seat under your legs
        </div>
    </div>
    <hr />
    <div>
      <img src="assets/img/Praanaayaamam2.jpg" className="img2" />

      <div className="hint">Wear a pavithram made with two dharbhams in the Rt ring finger
and fold two extra dharbhams along with it.
        </div>
    </div>
    <div className="clear"></div><hr />


    <div>
      <img src="assets/img/Praanaayaamam3.jpg" className="img2" />

      <div className="hint">Press the rt nostrils with rt thumb
      </div>
    </div>

    <div className="clear"></div><hr />
    <div>
      <img src="assets/img/Praanaayaamam4.jpg" className="img2" />
      <div className="hint"> Fold both index and middle fingers towards inside, shut the mouth, inhale outside air through left nostril to fill your lung
then shut the lt nostrils also using ring and little finger.
<br />recite the below manthra thrice to complete one praaNaayaama
        </div>
    </div>
    <div className="clear"></div><hr />

    <div className="prayogam">Om bhoohu Om bhuvaha O(gu)m suvaha Om mahaha Om janaha Om thapaha Om sathyam tatsavidhurvareaNyam bhargodhevasya dheemahi
      dhiyoyonah prachodhayaadh Omaapaha jyotheerasaha amrutham brahma bhoor bhuva suvar Om</div>
    <div className="hint">
    The inner air should be released little by little and at the end touch the rt ear by little finger while
saying the end part of the manthra 'Om'. </div>
  <hr />
  <div className="head2">ப்ராணாயாமம்</div>
  <hr />
  <div className="sans">
    ओं भू:। ओं भुव:। ओँसुव:। ओं मह:। ओं जन:। ओं तप:। ओँसत्यम्। ओं तत्सवितुर्वरेण्यं भर्गो देवस्य धीमहि । धियो यो न: प्रचोदयात्।
    ओमापो ज्योती रसोऽमूतं ब्रह्म भूर्भुवस्वरोम्।।
  </div>
 <hr />

  <div>
    <img src="assets/img/praanaayaamam.gif" />
  </div>


  <div className="item">Vada Kalai To Start</div>
<hr />
  <div>
    <img src="assets/img/kaikoopu.jpg" className="img2" />
    <div className="hint">Keep both hands as shown  doing Namaskaram
    </div>
  </div>
<hr />

  <div className="prayogam">Om asmath gurubhyo namaha.
Sreemaan venkata naathaaryaha Kavithrkika kesari
Vedaanthaacharya varyome; Sannidhattham sadhahrudhi.
Gurubhyaha - thath gurubhyascha namovakam atheemahe
Vruneemahecha thathraadhyau dhampathi jagadhampathi
Swasesha bhuuthena maya sveeyai:(hi) sarva parichathai:(hi)
Vidhathum preetam aatmaanam deva:(ha) prakramadhe swayam.</div>
    <hr />
  <div className="sans">
    ओं अस्मत्गुरुभ्या नम:। श्रीमान् वेङ्कटनाथार्य: कवितार्किककेसरी। वेवान्ताचार्यवर्यो मे सिन्नधत्तां सदाहृदि|| गुरुभ्य: तद्गुरुभ्यश्च
    नमोवाकं अधीमहे। वृणीमहे च तत्राद्यौ दम्पती जगतां पती ।। स्वशेष भूतेन मया स्वीयै: सर्वपरिच्छदै: । विधातुं प्रीतमात्मानं
    देव: प्रक्रमते स्वयम् ।।

  </div>
  <hr />
  <div className="item">Manthram Common for All </div>

  <div className="prayogam">
      Suklambharadharam vishnum sasivarnam chathur bhujam
Prasanna vadhanam dhyayedh sarva vigna upasaanthaye.
Yasyadhvradha vakrathyaha paarishathyaaha parassadham
Vignam nignandhi sadhadham vishvaksenam tham aashraye.
  </div>
  <hr />
  <div className="sans">
    शुक्लाम्बरधरं विष्णुं शशिवर्णं चतुर्भुजम् । प्रसन्नवदनं ध्यायेत् सर्वविघ्नोपशान्तये ।। यस्यद्विरदवक्त्राद्या: पारिषद्या:
    पर:शतम् । विघ्नं निघ्नन्ति सततं विष्वसेनं तमाश्रये ।।

  </div>
<hr />
  <div>
    <img src="assets/img/Sankalpam.jpg" className="img2" />
    <div className="hint">keep the left hand as open in right thigh, place the right hand
on it as closing</div>
  </div>

  <div className="clear"></div><hr />
  <div className="prayogam">Hari:(hi) Om Thath(u).<br />
    Sri Govindha Govindhagovindha Asya sri bhagavadha:(ha) Maha purushasya Sri Vishno:(ho) ajgnaya pravarthamanasya adhya brahmana:(ha) dvidhiya parardhe sri swedhavaraha kalpe vaivasvadha manvanthare kaliyuge prathame padhe
  </div>

  <div className="svk">For people in India</div>
  <div className="prayogam"> Jambhu dweepe Bharadha varshe bharadhakhande

  </div>

  <div className="svk">
      For people outside India:
      You can replace the word ‘Vishnu’ in all places for which you dont know the names of dweepam, varsham and kandam Example: Vishnu dweepe, Vishnu Varshe, Vishu Khande.

  </div>
<hr />
  <div className="svk">Manthram continues for all</div>
  <div className="prayogam">Sakaapthe meroho dhakshine paarswe asmin varthamaanaanaam
   vyavaharike Prabhavaadhi shasti samvathsaraanaam madhye .....
    .....</div>
    <hr />
  <div className="sans">
    हरि: ओं तत् (सत्) श्रीगोविन्द गोविन्द गोविन्द। अस्य श्रीभगवत: महापुरुषस्य श्रीविष्णो: आज्ञया प्रवर्तमानस्य अद्यब्रह्मण: द्वितीयपराार्धे
    श्रीश्वेतवराहकल्पे वैवस्त्वत मन्वन्तरे कळियुगे प्रथमेपादे जम्बूद्वीपे भारतवर्षे भरतखण्डे शकाब्दे मेरो: दक्षिणेपार्श्वे
    अस्मिन् वर्तमानानां व्यवहारिकाणां प्रभवादीनां षष्टिसंवत्सराणां मध्ये
  </div>
  <div className="clear"></div>

<hr />
  <div className="head2">
   Sankalpam for 13-09-2026 :
  </div>
  <div className="svk2">13-09-2026-Sankalpam - Audio </div>
    <audio controls>
    <source src="/assets/audio/13-09-2026.mp3" type="audio/mp3" />
  Your browser does not support the audio element.
  </audio>
  <hr />

  <div className="prayogam">

    parabhava Naama Samvatsare -  dhakshinayane
    varsha ruthau
    simha mase
    sukla pakshe
    thvitheeyaayaam (till 08.25 am after that thruthiyaayaam) subha thithau
    bhaanu vaasara yukthayam
    hastha nakshatra yukthaayam
    subhra yoga yukthaayam
    kaulava karana yukthaayam
    yevanguna visehana visishtaayam thvitheeyaayaam (thruthiyaayaam) subha thithau

    </div>
  <hr />
  <div className="sans">
    .... पिल्व  नाम संवत्सरे ... दक्षिणयने - वर्ष ऋतौ
     सिंह मासे शुक्ल पक्षे   द्वितीयायां
    शुभ तिथौ वासर: गुरु वासर  युक्तायां
    हस्त नक्षत्र युक्तायां सुब्र योग युक्तायां
    तैतुल करण युक्तायां एवङ्गुण विशेषण
    विशिष्टायां अस्यां द्वितीयायां  शुभ
    तिथौ श्रीभगवदाज्ञया श्रीमन्नारायण प्रीत्यर्थं
  </div>

   <div className="mydiv">ஸ்ரீ-ம் (Hint:- Please keep this in mind to say as per your sampradayam wherever you find
   "Sri-m:"<br />
    <span style={{"backgroundColor": "yellow"}}> Vada Kalai :</span>
    Sri bhagavadhagnaya Sriman Narayana preethyartham,
    <br /> <span style={{"backgroundColor": "yellow"}}>Then Kalai : </span>
    Sri bhagavadhagnaya bhagavath kainkarya roopam,
    <br /> <span style={{"backgroundColor": "yellow"}}>ஸ்மார்த்தா</span>
     Mamo paatha samastha durithakshaya dwara , Sri Parameshwara preethyartham  </div>
     <div className="hint">Both kalai and Smarthaa to continue :</div>
    <div className="clear"></div>

<hr />
<div className="bigdiv">
  As per Sama veda practice, the yajgnopaveetam should be worn at the end
  after tarpanam. <br /> So it is given at the end,
  whoever want to change poonal before starting the rushi tarpanam, please
  go to the end and return here after wearing poonal.
<hr />
  No 'kamokarsheet japam for Sama Vedins.
        </div>


<div className="svk2">
    Sri Bhagavat Aajgayaa sriman naraayaNa preetyartam or
     bhagavat kainkarya ruupam adhyaaya utsarjana karmaNi
     devarushi pitru preetyartam devarushi pitru tarpaNam karishye.<br />
  Leave the short darbhams (if) at left.
  </div>
<hr className="new" />


 <h2>Deva Tarpanam - Upaveeti -as usual</h2>
 <div className="hint"> Keep poonal Upaveeti as usual.
    Keep two 'erukku' leaves and two dharbhams on that
    (as shown) and have some akshatai on it, and pour water a little
    for each manthram, water to be drop down<span style={{"backgroundColor": "yellow"}}>
        towards East</span>.
  </div>
  <div className="mydiv">
    <img src="assets/img/sama-deva-tarpanam.jpg" style={{"width": "90%"}} />
  </div>
  <div className="english">
1.agniḥ tṛpyatu<hr />
 2.brahmā tṛpyatu<hr />
3.somaḥ tṛpyatu<hr />
4.śivaḥ tṛpyatu<hr />
5.prajāpatiḥ tṛpyatu<hr />
6.savitā tṛpyatu<hr />
7.indraḥ tṛpyatu<hr />
8.brṛhaspatiḥ tṛpyatu<hr />
9.tvaṣṭā tṛpyatu<hr />
10.viṣṇuḥ tṛpyatu<hr />
11.yamaḥ tṛpyatu<hr />
12.vāyuḥ tṛpyatu<hr />
13.ādityaḥ tṛpyatu<hr />
14.candramāḥ tṛpyatu<hr />
15.nakṣatrāṇi tṛpyaṁtu<hr />
16.sahadevatābhiḥ vasavaḥ tṛpyantu<hr />
17rudrāḥ  tṛpyaṁtu<hr />
18.ādityāḥ  tṛpyaṁtu<hr />
19.bhṛgavaḥ  tṛpyaṁtu<hr />
20.aṅgirasaḥ tṛpyaṁtu<hr />
21.sādhyāḥ tṛpyaṁtu<hr />
22.marutaḥ tṛpyaṁtu<hr />
23.viśvedevāḥ tṛpyaṁtu<hr />
24.sarvedevāḥ  tṛpyaṁtu<hr />
25.vāk ca   tṛpyatu<hr />
26.manaśca   tṛpyatu<hr />
27.āpaśca  tṛpyatu<hr />
28.oṣadhayaśca  tṛpyaṁtu<hr />
29.indrāgnī tṛpyatām<hr />
30.dhātā  tṛpyatu<hr />
31.aryamā  tṛpyatu<hr />
32.sārdhamāsartavaḥ tṛpyaṁtu<hr />
33.ditiḥ  tṛpyatu<hr />
34.aditiḥ  tṛpyatu<hr />
35.indrāṇi  tṛpyatu<hr />
36.umā  tṛpyatu<hr />
37.śrīśca  tṛpyatu<hr />
38.sarvāśca devapatnyaḥ
39.rudraḥ  tṛpyatu<hr />
40.skandaviśākhau
41.viśvakarmā  tṛpyatu<hr />
42.darśaśca  tṛpyatu<hr />
43.paurṇamāsaśca  tṛpyatu<hr />
44.cāturvedyaṁ  tṛpyatu<hr />
45.cāturhautraṁ  tṛpyatu<hr />
46.vaihārikāḥ  tṛpyaṁtu<hr />
47.pākayajñāḥ tṛpyaṁtu<hr />
48.sthāvarajaṅgame
49.parvatāśiṣaḥ tṛpyaṁtu<hr />
50.bhavyaḥ  tṛpyatu<hr />
51.nadyaḥ  tṛpyatu<hr />
52.samudraḥ  tṛpyatu<hr />
53.apāṁpatiḥ  tṛpyatu<hr />
54.yajamānā ye devāḥ  ekādaśakāḥ trayaśca trīṇi ca śatāḥ
56.trayaśca trīṇi ca sahasrāḥ tṛpyantu<hr />
55.dvipavitryā devāḥ tṛpyantām<hr />
56.eka pavitryā devāḥ manuṣya 				prabhṛtayaḥ tṛpyaṁtu<hr />

57.saṁkarṣaṇa vāsudevau tṛpyetām<hr />
58.dhanvantariḥ tṛpyatu<hr />
59.sādhukāraḥ tṛpyatu<hr />
60udara vaiśravaṇa pūrṇabhadra 				māṇibhadrāḥ  tṛpyantu<hr />
61yātudhānāḥ tṛpyantu<hr />
62.yakṣāḥ tṛpyantu<hr />
63.rakṣāṁsi tṛpyantu<hr />
64.itara gaṇāḥ tṛpyantu<hr />
65.traiguṇyaṁ tṛpyatu<hr />
66.nāma ākhyāta upasarga nipātāḥ tṛpyantu<hr />
67.devarṣayaḥ tṛpyantu<hr />
68.mahāvyāgṛdayaḥ tṛpyantu<hr />
69.sāvitrī tṛpyatu<hr />
70.ṛcaḥ  tṛpyantu<hr />
71.yajnūṁṣi tṛpyantu<hr />
72.sāmāni tṛpyantu<hr />
73.kāṇḍāni tṛpyantu<hr />
74.eṣāṁ daivatāni tṛpyantu<hr />
75.prāyaścittāni tṛpyantu<hr />
76.śukriyopaniṣadaḥ tṛpyantu<hr />
77.śokī tṛpyatu<hr />
78.śukaḥ tṛpyatu<hr />
79.śākalyaḥ tṛpyatu<hr />
80.pāñcālaḥ tṛpyatu<hr />
81.ṛcābhiḥ tṛpyatu</div>

<div className="wrapper">

    <div className="half">
      <div className="tab blue">
        <input id="tab-01" type="radio" name="tabs2" />
        <label for="tab-01">01-Sanskrit Text</label>
        <div className="tab-content">
<div className="sans">
    देवतर्पणम् उपवीति<hr />
    १. अग्नि:	तृप्यतु<hr />
    २. ब्रह्मा	तृप्यतु<hr />
    ३. सोम:	तृप्यतु<hr />
    ४. शिव:	तृप्यतु<hr />
    ५.प्रजापति:	तृप्यतु<hr />
    ६. सविता	तृप्यतु<hr />
    ७. इन्द्र:	तृप्यतु<hr />
    ८. बृहस्पति:	तृप्यतु<hr />
    ९. त्वष्टाा	तृप्यतु<hr />
    १०. विष्णु:	तृप्यतु<hr />
    ११. यम:	तृप्यतु<hr />
    १२. वायु:	तृप्यतु<hr />
    १३. आदित्य:	तृप्यतु<hr />
    १४. चन्द्रमा:	तृप्यतु<hr />
    १५. नक्षत्राणि	तृप्यन्तु<hr />
    १६. सहदेवताभि: वसव:	तृप्यन्तु<hr />
    १७. रुद्रा:	तृप्यन्तु<hr />
    १८. आदित्या: 	तृप्यन्तु<hr />
    १९. भृगव:	तृप्यन्तु<hr />
    २०. अंगिरस:	तृप्यन्तु<hr />
    २१. साध्या:	तृप्यन्तु<hr />
    २२. मरुत:	तृप्यन्तु<hr />
    २३. विश्वेदेवा:	तृप्यन्तु<hr />
    २४. सर्वेदेवा:	तृप्यन्तु<hr />
    २५. वाक् च	तृप्यतु<hr />
    २६. मनश्च	तृप्यतु<hr />
    २७. आपश्च	तृप्यतु<hr />
    २८. ओषधयश्च	तृप्यतु<hr />
    २९. इन्द्राग्नी 	तृप्यताम्<hr />
    ३०. धाता	तृप्यतु<hr />
    ३१. अर्यमा	तृप्यतु<hr />
    ३२. सार्धमार्स्तव:	तृप्यन्तु<hr />
    ३३. दिति:	तृप्यतु<hr />
    ३४. अदिति:	तृप्यतु<hr />
    ३५. इन्द्राणी	तृप्यतु<hr />
    ३६. उमा	तृप्यतु<hr />
    ३७. श्रीश्च	तृप्यतु<hr />
    ३८. सर्वाश्च देवपत्न्य:	तृप्यन्तु<hr />
    ३९. रुद्र:	तृप्यतु<hr />
    ४०.स्कन्दविशाखौ	तृप्यताम्<hr />
    ४१. विश्वकर्मा	तृप्यतु<hr />
    ४३. पौर्णमासश्च	तृप्यतु<hr />
    ४४. चातुर्वेद्यं	तृप्यतु<hr />
    ४५. चातुर्हौत्रं	तृप्यतु<hr />
    ४६. वैकारिका:	तृप्यन्तु<hr />
    ४७. पाकयज्ञा:	तृप्यन्तु<hr />
    ४८. स्थावरजङ्गमे	तृप्यताम्<hr />
    ४९. पर्वताश्षि:	तृप्यन्तु<hr />
    ५०. भव्य:	तृप्यतु<hr />
    ५१. नद्य:	तृप्यतु<hr />
    ५२. समुद्र:	तृप्यतु<hr />
    ५३. अपांपति:	तृप्यतु<hr />
    ५४. यजमाना: येदेवास्तु एकादशका:
    त्रयश्च त्रिंशच्च त्रयश्च त्रीणीच शता:
    त्रयश्च त्रीणीच सहस्रा: तृप्यन्तु<hr />
    ५५. िद्वपवित्र्या देवा: 	तृप्यन्तु<hr />
    ५६. एकपवित्र्या देवा: मनुष्य प्रभृतय:	तृप्यन्तु<hr />


    ५७. संकर्षण वासुदेवौ 	तृप्यताम्<hr />
    ५८. धन्वन्तराि:	तृप्यतु<hr />
    ५९. साधुकार:	तृप्यतु<hr />
    ६०. उदरवैश्रवण पूर्णभद्र माणिभद्रा:	तृप्यन्तु<hr />

    ६१. यातुधाना:	तृप्यन्तु<hr />
    ६२. यक्षा:	तृप्यन्तु<hr />
    ६३. रक्षांसि	तृप्यन्तु<hr />
    ६४. इदरगणा:	तृप्यन्तु<hr />
    ६५. त्रैगुण्यं्र	तृप्यतु<hr />
    ६६. नामाख्यात उपसर्ग निपाता:	तृप्यन्तु<hr />
    ६७. देवर्षय:	तृप्यन्तु<hr />
    ६८. महाव्या=दय:	तृप्यन्तु<hr />
    ६९. सावित्री	तृप्यतु<hr />
    ७०. ऋच:	तृप्यन्तु<hr />
    ७१. यजूंषि	तृप्यन्तु<hr />
    ७३. सामानि	तृप्यन्तु<hr />
    ७४. काण्डानि	तृप्यन्तु<hr />
    ७५. एषां दैवतानि	तृप्यन्तु<hr />
    ७६. शुक्रियोपनिषद:	तृप्यन्तु<hr />
    ७७. शोकी	तृप्यतु<hr />
    ७८. शुक:	तृप्यतु<hr />
    ७९. साकल्य:	तृप्यतु<hr />
    ८०. पाञ्चाल:	तृप्यतु<hr />
    ८१. ऋचाभि:	तृप्यन्तु<hr />
    </div>
</div></div>
<div className="tab blue">
    <input id="tab-02" type="radio" name="tabs2" />
    <label for="tab-02">Close - Sanskrit Text</label>
    <div className="tab-content">

      </div></div>
</div></div>

<div className="clear"></div>
<hr className="new" />
 <h2>Rushi tharppaNam – Niveeti- poonal as   garland</h2>
 <div className="hint"> Keep poonal Upaveeti as usual.
     Keep two 'erukku' leaves and two dharbhams on that
     (as shown) and have some akshatai on it, and pour water a little
     for each manthram, water to be drop down<span style={{"backgroundColor": "yellow"}}>
         towards North</span>.
   </div>
<div className="mydiv">
    <img src="assets/img/sama-rishi-tarpanam.jpg" style={{"width": "90%"}} />
  </div>
<div className="english">
82.vyāsaḥ tṛpyatu<hr />
83.pārāśaryaḥ tṛpyatu<hr />
84.tāṇḍī tṛpyatu<hr />
85.kukī tṛpyatu<hr />
86.kauśikī tṛpyatu<hr />
87.baḍabā tṛpyatu<hr />
88.prātitheyī tṛpyatu<hr />
89.maitrāyaṇī tṛpyatu<hr />
90.dākṣāyaṇī tṛpyatu<hr />
91.sarvācāryāḥ tṛpyantu<hr />
92.kulācāryāḥ tṛpyantu<hr />
93.gurukulavāsinaḥ tṛpyantu<hr />
94.kanyā tṛpyatu<hr />
95.brahmacārī tṛpyatu<hr />
96.ātmārthī tṛpyatu<hr />
97.yājñavalkyaḥ tṛpyatu<hr />
98.rāṇāyanī tṛpyatu<hr />
99.sātyamugrī tṛpyatu<hr />
100.durvāsāḥ tṛpyatu<hr />
101.bhāgurī tṛpyatu<hr />
102.gauruṇḍī tṛpyatu<hr />
103.gaulgulavī tṛpyatu<hr />
104.bhagavān aupamanyavaḥ tṛpyatu<hr />
105.dārālaḥ tṛpyatu<hr />
106.gārgisāvarṇī tṛpyatu<hr />
107.varṣagaṇyaśca tṛpyatu<hr />
108.kuthumiśca tṛpyatu<hr />
109.śālihotraśca tṛpyatu<hr />
110.jaiminiśca tṛpyatu<hr />
111.śaṭiḥ tṛpyatu<hr />
112.bhāllabaviḥ tṛpyatu<hr />
113.kālabaviḥ tṛpyatu<hr />
114.tāṇḍyaḥ tṛpyantu<hr />
115.vṛśca tṛpyatu<hr />
116.vṛṣāṇakaśca tṛpyatu<hr />
117.rurukiśca tṛpyatu<hr />
118.agastyaḥ tṛpyatu<hr />
119.baṭkaśirāḥ tṛpyatu<hr />
120.kuhūśca tṛpyatu</div>

<div className="wrapper">

    <div className="half">
      <div className="tab blue">
        <input id="tab-03" type="radio" name="tabs2" />
        <label for="tab-03">03-Sanskrit Text</label>
        <div className="tab-content">
<div className="sans">
    (ऋषि तर्पणम् निवीति)<hr />
    ८२. व्यास:	तृप्यतु<hr />
    ८३. पाराशर्य:	तृप्यतु<hr />
    ८४. ताण्डी	तृप्यतु<hr />
    ८५. कुकी	तृप्यतु<hr />
    ८६. कौशिकी	तृप्यतु<hr />
    ८७. बडबा	तृप्यतु<hr />
    ८८. प्रातिथेयी	तृप्यतु<hr />
    ८९. मैत्रायणी	तृप्यतु<hr />
    ९०. दाक्षायणी	तृप्यतु<hr />
    ९१. सर्वाचार्या:	तृप्यन्तु<hr />
    ९२. कुलाचार्या:	तृप्यन्तु<hr />
    ९३. गुरुकुलवासिन:	तृप्यन्तु<hr />
    ९४. कन्या	तृप्यतु<hr />
    ९५. ब्रह्मचारी	तृप्यतु<hr />
    ९६. आत्मार्थी	तृप्यतु<hr />
    ९७. याज्ञवल्क्य:	तृप्यतु<hr />
    ९८. राणायनी	तृप्यतु<hr />
    ९९. सात्यमुग्री	तृप्यतु<hr />
    १००. दुर्वासा:	तृप्यतु<hr />
    १०१. भागुरी	तृप्यतु<hr />
    १०२. गौरुण्डी	तृप्यतु<hr />
    १०३. गौल्गुलवी	तृप्यतु<hr />
    १०४. भगवान् औपमन्यव:	तृप्यतु<hr />
    १०५. दाराल:	तृप्यतु<hr />
    १०६. गार्गिसावर्णी	तृप्यतु<hr />
    १०७. वर्षगण्यश्च	तृप्यतु<hr />
    १०८. कुथुमिश्च	तृप्यतु<hr />
    १०९. शालिहोत्रश्च	तृप्यतु<hr />
    ११०. जैमिनिश्च	तृप्यतु<hr />
    १११. शटि:	तृप्यतु<hr />
    ११२. भाल्लबवि:	तृप्यतु<hr />
    ११३. कालबवि:	तृप्यतु<hr />
    ११४. ताण्ड्य:	तृप्यतु<hr />
    ११५. वृश्च	तृप्यतु<hr />
    ११६. वृषाणकश्च	तृप्यतु<hr />
    ११७. रुरुकिश्च	तृप्यतु<hr />
    ११८. अगस्त्य:	तृप्यतु<hr />
    ११९. बट्कशिरा:	तृप्यतु<hr />
    १२०. कुहूश्च	तृप्यतु<hr />
    दशइत्येते प्रवचन कर्तार:
    स्वस्तिकुर्वन्तु तर्पिता: (२)
    </div>
  </div></div>
  <div className="tab blue">
      <input id="tab-04" type="radio" name="tabs2" />
      <label for="tab-04">Close - Sanskrit Text</label>
      <div className="tab-content">

        </div></div>
  </div></div>

<hr className="new" />
 <h2>Deva Tarpanam - Upaveeti -as usual</h2>
 <div className="hint"> Keep poonal Upaveeti as usual.
    Keep two 'erukku' leaves and two dharbhams on that
    (as shown) and have some akshatai on it, and pour water a little
    for each manthram, water to be drop down<span style={{"backgroundColor": "yellow"}}>
        towards East</span>.
  </div>
  <div className="mydiv">
    <img src="assets/img/sama-deva-tarpanam.jpg" style={{"width": "90%"}} />
  </div>
  <div className="english">
121.agniḥ tṛpyatu<hr />
122.brahma tṛpyatu<hr />
123.devāḥ   tṛpyantu<hr />
124.vedāḥ  tṛpyantu<hr />
125.oṁkāraḥ tṛpyatu<hr />
126.sāvitri tṛpyatu<hr />
127.yajñāḥ tṛpyatu<hr />
128.dyāvāpṛthivi tṛpyatām
129.ahorātrāṇi tṛpyantu<hr />
130.sāṁkhyāḥ tṛpyantu<hr />
131.samudrāḥ tṛpyantu<hr />
132.kṣetrauṣadhi vanaspatayaḥ tṛpyantu<hr />
133.gandharvāḥ tṛpyantu<hr />
134.apsarasaḥ tṛpyantu<hr />
135.nāgāḥ tṛpyantu<hr />
136.yakṣāḥ tṛpyantu<hr />
137.rakṣāṁsi tṛpyantu<hr />
  bhūtāṁścaiva anumanyantām</div>

  <div className="wrapper">

      <div className="half">
        <div className="tab blue">
          <input id="tab-05" type="radio" name="tabs2" />
          <label for="tab-05">04-Sanskrit Text</label>
          <div className="tab-content">
              <div className="sans">
                  देव तर्पणम् - उपवीति<hr />
                  १२१. अग्नि: 	तृप्यतु<hr />
                  १२२. ब्रह्मा	तृप्यतु<hr />
                  १२३. देवा:	तृप्यन्तु<hr />
                  १२४. वेदा:	तृप्यन्तु<hr />
                  १२५. ओंकार:	तृप्यतु<hr />
                  १२६. सावित्री	तृप्यतु<hr />
                  १२७. यज्ञा:	तृप्यतु<hr />
                  १२८. द्यावापृथिवी	तृप्यताम्<hr />
                  १२९. अहोरात्राणि	तृप्यन्तु<hr />
                  १३०. सांख्या:	तृप्यन्तु<hr />
                  १३१. समुद्रा:	तृप्यन्तु<hr />
                  १३२. क्षेत्रौषधि वनस्पतय:	तृप्यन्तु<hr />
                  १३३. गन्धर्वा:	तृप्यन्तु<hr />
                  १३४. अप्सरस:	तृप्यन्तु<hr />
                  १३५. नागा:	तृप्यन्तु<hr />
                  १३६. यक्षा:	तृप्यन्तु<hr />
                  १३७. रक्षांसि	तृप्यन्तु<hr />
                  भूतांश्चैव अनुमन्यन्ताम्
                  </div>
                </div></div>
                <div className="tab blue">
                    <input id="tab-06" type="radio" name="tabs2" />
                    <label for="tab-06">Close - Sanskrit Text</label>
                    <div className="tab-content">

                      </div></div>
                </div></div>

<hr className="new" />
 <h2>Rushi tharppaNam – Niveeti- poonal as   garland</h2>
 <div className="hint"> Keep poonal Upaveeti as usual.
     Keep two 'erukku' leaves and two dharbhams on that
     (as shown) and have some akshatai on it, and pour water a little
     for each manthram, water to be drop down<span style={{"backgroundColor": "yellow"}}>
         towards North</span>.
   </div>
<div className="mydiv">
    <img src="assets/img/sama-rishi-tarpanam.jpg" style={{"width": "90%"}} />
  </div>
 <div className="english">
138.sumantuḥ tṛpyatu<hr />
139.jaiminiḥ tṛpyatu<hr />
140.viśvāmitraḥ tṛpyatu<hr />
141.vasiṣṭhaḥ tṛpyatu<hr />
142.parāśaraḥ tṛpyatu<hr />
143.jānantuḥ tṛpyatu<hr />
144.bāhavaḥ tṛpyatu<hr />
145.gautamaḥ tṛpyatu<hr />
146.śākalyaḥ tṛpyatu<hr />
147.bābhravyaḥ tṛpyatu<hr />
148.māṇḍavyaḥ tṛpyatu<hr />
149.baḍabā tṛpyatu<hr />
150.Prātitheyī tṛpyatu</div>

<div className="wrapper">

    <div className="half">
      <div className="tab blue">
        <input id="tab-07" type="radio" name="tabs2" />
        <label for="tab-07">05-Sanskrit Text</label>
        <div className="tab-content">

 <div className="sans">
ऋषि तर्पणम् निवीति<hr />
१३८. सुमन्तु:	तृप्यतु<hr />
१३९. जैमिनि:	तृप्यतु<hr />
१४०. विश्वमित्र:	तृप्यतु<hr />
१४१. वसिष्ठ:	तृप्यतु<hr />
१४२. पराशर:	तृप्यतु<hr />
१४३. जानन्तु:	तृप्यतु<hr />
१४४. बाहव:	तृप्यतु<hr />
१४५. गौतम:	तृप्यतु<hr />
१४६. शाकल्य:	तृप्यतु<hr />
१४७. बाभ्रव्य:	तृप्यतु<hr />
१४८. माण्डव्य:	तृप्यतु<hr />
१४९. बडबा	तृप्यतु<hr />
१५०. प्रतिथेयी	तृप्यतु
</div>
</div></div>
<div className="tab blue">
    <input id="tab-08" type="radio" name="tabs2" />
    <label for="tab-08">Close - Sanskrit Text</label>
    <div className="tab-content">

      </div></div>
</div></div>

<hr className="new" />
 <h2>Deva Tarpanam - Upaveeti -as usual</h2>
 <div className="hint"> Keep poonal Upaveeti as usual.
    Keep two 'erukku' leaves and two dharbhams on that
    (as shown) and have some akshatai on it, and pour water a little
    for each manthram, water to be drop down<span style={{"backgroundColor": "yellow"}}>
        towards East</span>.
  </div>
  <div className="mydiv">
    <img src="assets/img/sama-deva-tarpanam.jpg" style={{"width": "90%"}} />
  </div>
  <div className="english">
151.namo brahmaṇe tṛptirastu <hr />
152.namo brāhmaṇebhyaḥ tṛptirastu <hr />
153.nama ācāryebhyaḥ tṛptirastu <hr />
154.nama ṛṣibhyaḥ tṛptirastu <hr />
155.namo devebhyaḥ tṛptirastu <hr />
156.namo vedebhyaḥ tṛptirastu <hr />
157.namo vāyaveśca tṛptirastu <hr />
158.mṛtyaveśca tṛptirastu <hr />
159.viṣṇaveśca tṛptirastu <hr />
160.namo vaiśravaṇāya ca tṛptirastu </div>
<div className="wrapper">

    <div className="half">
      <div className="tab blue">
        <input id="tab-09" type="radio" name="tabs2" />
        <label for="tab-09">06-Sanskrit Text</label>
        <div className="tab-content">
<div className="sans">
देव तर्पणम्  उपवीति<hr />
१५१. ओं नमो ब्रह्मणे	तृप्तिरस्तु<hr />
१५२. ओं नमो ब्रह्मणेभ्य:	तृप्तिरस्तु<hr />
१५३. नम आचार्येभ्य:	तृप्तिरस्तु<hr />
१५४. नम ऋषिभ्य:	तृप्तिरस्तु<hr />
१५५. नमो देवेभ्य:	तृप्तिरस्तु<hr />
१५६. नमोवेदेभ्य:	तृप्तिरस्तु<hr />
१५७. नमो वायवे च	तृप्तिरस्तु<hr />
१५८. मृत्यवे च 	तृप्तिरस्तु<hr />
१५९. विष्णवे च	तृप्तिरस्तु<hr />
१६०. नमो वैश्रवणाय च 	तृप्तिरस्तु
</div>
</div></div>
<div className="tab blue">
    <input id="tab-10" type="radio" name="tabs2" />
    <label for="tab-10">Close - Sanskrit Text</label>
    <div className="tab-content">

      </div></div>
</div></div>




<hr className="new" />
 <h2>Rushi tharppaNam – Niveeti- poonal as   garland</h2>
 <div className="hint"> Keep poonal Upaveeti as usual.
     Keep two 'erukku' leaves and two dharbhams on that
     (as shown) and have some akshatai on it, and pour water a little
     for each manthram, water to be drop down<span style={{"backgroundColor": "yellow"}}>
         towards North</span>.
   </div>
<div className="mydiv">
    <img src="assets/img/sama-rishi-tarpanam.jpg" style={{"width": "90%"}} />
  </div>
 <div className="english">
161.śarvadattāt gārgyāt
		     upajāyata tasmainamaḥ tṛptirastu <hr />
162.śarvadattaḥ gārgyaḥ rudrabhūteḥ drāhyāyaṇeḥ  upajāyata tasmainamaḥ tṛptirastu <hr />
163.rudrabhūtiḥ drāhyāyaṇiḥ trātāt aiṣumatāt upajāyata tasmainamaḥ tṛptirastu <hr />
164.trātaḥ aiṣumataḥ nigaḍāt pārṇavalkeḥ upajāyata tasmainamaḥ tṛptirastu <hr />
165.nigaḍaḥ pārṇavalkiḥ giriśarmaṇaḥ kāṇḍe viddheḥ upajāyata tasmainamaḥ tṛptirastu <hr />
166.giriśarmā kāṇḍeviddhiḥ brahmavṛddheḥ chandogamāhakeḥ upajāyata tasmainamaḥ tṛptirastu <hr />
167.brahmavṛddhiḥ chandogamāhakiḥ mitra varcasaḥ sthairakāyanāt upajāyata tasmainamaḥ tṛptirastu <hr />
168.mitravarcāḥ sthairakāyanaḥ supratītāt aulundyāt upajāyata tasmainamaḥ tṛptirastu <hr />

169.supratītaḥ aulundyaḥ bṛhaspati guptāt śāyastheḥ upajāyata tasmainamaḥ tṛptirastu <hr />

170.bṛhaspatiguptaḥ śāyasthiḥ bhavatrātāt śāyastheḥ upajāyata tasmainamaḥ tṛptirastu <hr />

171.bhavatrātaḥ śāyāsthiḥ kustukāt śārkarākṣāt upajāyata tasmainamaḥ tṛptirastu <hr />

172.kustukaḥ śārkarākṣaḥ śravaṇadattāt kauhalāt upajāyata tasmainamaḥ tṛptirastu <hr />

173.śravaṇadattaḥ kauhalaḥ suśāradāt
		śālaṁkāyanāt upajāyata tasmainamaḥ tṛptirastu <hr />
174.suśāradaḥ śālaṁkāyanaḥ ūrjayataḥ aupamanyavāt tṛptirastu <hr />
175.ūrjayan aupamanyavaḥ bhānumataḥ 					aupamanyavāt upajāyata tasmainamaḥ tṛptirastu <hr />
176.bhānumān aupamanyavaḥ ānandajāt 						cāndhanāyanāt upajāyata tasmainamaḥ tṛptirastu <hr />
177.ānandajaḥ cāndhanāyanaḥ śāmbāt śārkarākṣāt 				kāmbojācca aupamanyavāt upajāyata tasmainamaḥ tṛptirastu <hr />
178.śāmbaḥ śārkarākṣaḥ kāmbojaśca 				aupamanyavaḥ madragārāt śauṁgāyaneḥ upajāyata tasmainamaḥ tṛptirastu <hr />
179.madragāraḥ śauṁgāyaniḥ sāterauṣṭrākṣeḥ upajāyata tasmainamaḥ tṛptirastu <hr />

180.sātirauṣṭrākṣiḥ suśravasaḥ vārṣagaṇyāt upajāyata tasmainamaḥ tṛptirastu <hr />

181.suśravāḥ vārṣagaṇyaḥ prāranhāt kauhalāt upajāyata tasmainamaḥ tṛptirastu <hr />

182.prātarahnaḥ kauhalaḥ ketorvājyāt upajāyata tasmainamaḥ tṛptirastu <hr />
183.keturvājyaḥ mitravindāt kauhalāt upajāyata tasmainamaḥ tṛptirastu <hr />
184.mitravindaḥ kauhalaḥ sunīthāt kāpaṭavāt upajāyata tasmainamaḥ tṛptirastu <hr />
185.sunīthaḥ kāpaṭavaḥ sutemanasaḥ śāṇḍilyāyanāt upajāyata tasmainamaḥ tṛptirastu <hr />

186.sutemanāḥ śāṇḍilyāyanaḥ aṁśoḥ dhānañjayyāt upajāyata tasmainamaḥ tṛptirastu <hr />

187.aṁśuḥ dhānañjyyuḥ amāvāsyāt śāṇḍilyāyanāt 				rādhācca gautamāt upajāyata tasmainamaḥ tṛptirastu <hr />
188.rādhaḥ gautamaḥ gātuḥ gautamāt pituḥ upajāyata tasmainamaḥ tṛptirastu <hr />
189.gātā gautamaḥ saṁvargajitaḥ lāmakāyanāt pituḥ upajāyata tasmainamaḥ tṛptirastu <hr />
190.saṁvargajit lāmakāyanaḥ śākadāsāt bhāḍitāyanāt upajāyata tasmainamaḥ tṛptirastu <hr />
191.śākadāsaḥ bhāḍitāyanaḥ vicakṣaṇāt
			tāṇḍyāt pituḥ upajāyata tasmainamaḥ tṛptirastu <hr />
192.vicakṣaṇaḥ tāṇḍyaḥ gardabhīmukhāt śāṇḍilyāyanāt upajāyata tasmainamaḥ tṛptirastu <hr />
193.gardabhīmukhaḥ śāṇḍilyāyanaḥ udaraśāṇḍilyāt upajāyata tasmainamaḥ tṛptirastu <hr />
194.udara śāṇḍilyaḥ atidhanvanaśca śaunakāt 					maśakācca gārgyāt upajāyata tasmainamaḥ tṛptirastu <hr />
195.maśakaḥ gārgyaḥ sthirakāt gārgyāt pituḥ upajāyata tasmainamaḥ tṛptirastu <hr />
196.sthirakaḥ gārgyaḥ vāsiṣṭhāt caikitāneyāt upajāyata tasmainamaḥ tṛptirastu <hr />
197.vāsiṣṭhaḥ caikitāneyaḥ vāsiṣṭhāt
			āraihaṇyāt rājanyāt upajāyata tasmainamaḥ tṛptirastu <hr />
198.vāsiṣṭhaḥ āraihaṇyaḥ rājanyaḥ sumantrāt 					bābhravāt gautamāt upajāyata tasmainamaḥ tṛptirastu <hr />
199.sumantraḥ bābhravaḥ gautamaḥ śūṣāt
			vānheyāt bhāradvājāt upajāyata tasmainamaḥ tṛptirastu <hr />
200.śūṣaḥ vānheyaḥ bhāradvājaḥ arālāta
			dārteyāt śaunakāt upajāyata tasmainamaḥ tṛptirastu <hr />
201.arālaḥ dārteyaḥ śaunakaḥ dṛteḥ
		aindrotāt śaunakāt pituḥ upajāyata tasmainamaḥ tṛptirastu <hr />
202.dṛtiḥ aindrotaḥ śaunakaḥ
		indrotāt śaunakāt pitureva upajāyata tasmainamaḥ tṛptirastu <hr />
203.indrotaḥ śaunakaḥ vṛṣaśuṣṇāt vātāvatāt upajāyata tasmainamaḥ tṛptirastu <hr />

204.vṛṣaśuṣṇaḥ vātāvataḥ nikothakāt bhāyajātyāt upajāyata tasmainamaḥ tṛptirastu <hr />

205.nikothakaḥ bhāyajātyaḥ pratitheḥ devatarathāt upajāyata tasmainamaḥ tṛptirastu <hr />

206.pratithiḥ devatarathaḥ devatarasaḥ
				śāvasāyanāt pituḥ upajāyata tasmainamaḥ tṛptirastu <hr />
207.devatarāḥ śāvasāyanaḥ śavasaḥ pitureva upajāyata tasmainamaḥ tṛptirastu <hr />
208.śavāḥ agnibhuvaḥ kāśyapāt upajāyata tasmainamaḥ tṛptirastu <hr />
209.agnibhūḥ kāśyapaḥ indrabhuvaḥ kāśyapāt upajāyata tasmainamaḥ tṛptirastu <hr />
210.indrabhūḥ kāśyapaḥ mitrabhuvaḥ kāśyapāt upajāyata tasmainamaḥ tṛptirastu <hr />
211.mitrabhūḥ kāśyapaḥ vibhaṇḍakāt kāśyapāt pituḥ upajāyata tasmainamaḥ tṛptirastu <hr />
212.vibhaṇḍakaḥ kāśyapaḥ ṛśyaśṛṁgāt
			kāśyapāt pitureva upajāyata tasmainamaḥ tṛptirastu <hr />
213.ṛśyaśṛṁgaḥ kāśyapaḥ kaśyapāt pitureva upajāyata tasmainamaḥ tṛptirastu <hr />
214.kaśyapaḥ agneḥ upajāyata tasmainamaḥ tṛptirastu </div>

<div className="wrapper">

    <div className="half">
      <div className="tab blue">
        <input id="tab-11" type="radio" name="tabs2" />
        <label for="tab-11">07-Sanskrit Text</label>
        <div className="tab-content">

<div className="sans">
ऋषि तर्पणम् निवीति।<hr />
१६१. शर्वदत्तात् गार्ग्यात्  उपजायत तस्मै नम: तृप्तिरस्तु<hr />

१६२. शर्वदत्त: गार्ग्य: रुद्रभूते: द्राह्यायणे:	उपजायत तस्मै नम: तृप्तिरस्तु<hr />
१६३. रुद्रभूति: द्राह्यायणि: त्रातात् ऐषुमतात्	उपजायत तस्मै नम: तृप्तिरस्तु<hr />
१६४. त्रात: ऐषुमत: निगडात् पार्णवल्के:	उपजायत तस्मै नम: तृप्तिरस्तु<hr />
१६५. निगड: पार्णवल्कि: गिरिशर्मण: काण्डेविद्धे:	उपजायत तस्मै नम: तृप्तिरस्तु<hr />
१६६. गिरिशर्मा काण्डेवििद्ध: ब्रह्मवृद्धे: छन्दोगमाहके:उपजायत तस्मै नम: तृप्तिरस्तु<hr />

१६७. ब्रह्मवृिद्ध: छन्दोगमाहकि: मित्र वर्चस: स्थैरकायनात्  उपजायत तस्मै नम: तृप्तिरस्तु<hr />

१६८. मित्रवर्चा: स्थैरकायन: सुप्रतीतात् औलुन्द्यात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

१६९. सुप्रतीत: औलुन्द्य: बृहस्पतिगुप्तात् शायस्थे: उपजायत तस्मै नम: तृप्तिरस्तु<hr />

१७०. बृहस्पतिगुप्त: शायस्थि: भवत्रातात् शायस्थे: उपजायत तस्मै नम: तृप्तिरस्तु<hr />

१७१. भवत्रात: शायस्थि: कुस्तुकात् शार्कराक्षात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

१७२. कुस्तुक: शार्कराक्ष: श्रवणदत्तात् कौहलात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

१७३. श्रवणदत्त: कौहल: सुशारदात् शालंकायनात्	 उपजायत तस्मै नम: तृप्तिरस्तु<hr />

१७४. सुशारद: शालंकायन: उूर्जयत: औपमन्यवात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

१७५. उूर्जयन् औपमन्यव: आनन्दजात् चान्धनायनात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

१७६. भानुमान् औपमन्यव: आनन्दजात् छान्धनायनात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

१७७. आनन्दज: चान्धनायन: शाम्बात् शार्कराक्षात्
                                काम्बोजाच्च औपमन्यवात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />
१७८. शाम्ब: शार्कराक्ष: काम्बोजश्च औपमन्यव:
                                 मद्रगारात् शौंगायने:	 उपजायत तस्मै नम: तृप्तिरस्तु<hr />
१७९. मद्रगार: शौंगायनि: सातेरौष्ट्राक्षे: उपजायत तस्मै नम: तृप्तिरस्तु<hr />

१८०. साते रौष्ट्राक्षि: सुश्रवस: वार्षगण्यात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

१८१. सुश्रव: वार्षगण्य: प्रातरन्हात् कौहलात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

१८२. प्रातरह्न: कौहल: सुनीथात् कापटवात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />
१८३. केतुर्वाज्य: मित्रविन्दात् कौहलात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />
१८४. मित्रविन्द: कौहल: सुनीथात् कापटवात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />
१८५. सुनीथ: कापटव: सुतेमनस: शाण्डिल्यायनात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

१८६. सुतेमना: शाण्डिल्यायन: अंशो: धानंजय्यात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

१८७. अंशु: धानंजय्य: अमावास्यात् शाण्डिल्यायनात्
	राधाच्च गौतमात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />
१८८. राध: गौतम: गातु: गौतमात् पितु: उपजायत तस्मै नम: तृप्तिरस्तु<hr />
१८९. गाता गौतम: संवर्गजित: लामकायनात् पितु: उपजायत तस्मै नम: तृप्तिरस्तु<hr />
१९०. संवर्गजित् लामकायन: शाकदासात् भाडितायनात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

१९१. शाकदास: भाडितायन: विचक्षणात्
	ताण्डयात् पितु: उपजायत तस्मै नम: तृप्तिरस्तु<hr />
१९२. विचक्ष: ताण्डय: गर्दभीमुखात् शाण्डिल्यायनात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

१९३. गर्दभीमुख: शाण्डिल्यायन: उदरशाण्डिल्यात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />
१९४. उदरशाण्डिल्य: अतिधन्वनश्च शौनकात्
	मशकाश्च्च गार्ग्यात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />
१९५. मशक: गार्ग्य: स्थिरकात् गार्ग्यात् पितु: उपजायत तस्मै नम: तृप्तिरस्तु<hr />
१९६. स्थिरक: गार्ग्य: वासिष्ठात् चैकितानेयात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />
१९७. वासिष्ठ: आरैहण्य: राजन्य: सुमन्त्रात् बाभ्रवात् गौतमात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

१९८. वासिष्ठ: आरैहण्य: राजन्य: सुमन्द्रात् बाभ्रवात् शौनकात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

१९९. सुमन्त्र: बाभ्रव: गौतम: शूषात् वान्हेयात् भारद्वाजात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२००. शूष: वान्हेय: भारद्वाज: अरालात् दार्तेयात् शौनकात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२०१. अराल: दार्तेय: शौनक: दृते: ऐन्द्रोतात् शौनकात् पितु: उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२०२. दृति: ऐन्द्रोत: शौनक: इन्द्रोतात् शौनकात् पितुरेव उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२०३. इन्द्रोत: शौनक: वृषशुष्णात् वातावतात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२०४. वृषशुष्ण: वातावत: निकोथकात् भायजात्यात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२०५. निकोथक: भायजात्य: प्रतिथे: देवतरथात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२०६. प्रतिथि: देवतरथ: देवतरस: शावसायनात् पितु: उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२०७. देवतरा: शावसायन: शवस: पितुरेव उपजायत तस्मै नम: तृप्तिरस्तु<hr />
२०८. शवा: अग्निभुव: काश्यपात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />
२०९. अग्निभू: काश्यप: इन्द्रभुव: काश्यपात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />
२१०. इन्द्रभू: काश्यप: मित्रभुव: काश्यपात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />
२११. मित्रभू:  काश्यप: विभण्डकात् काश्यपात् पितु: उपजायत तस्मै नम: तृप्तिरस्तु<hr />
२१२. विभण्डक: काश्यप: ऋश्यशृंगात् काश्यपात् पितुरेव उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२१३. ऋश्यशृंग: काश्यप: कश्यपात् पितुरेव उपजायत तस्मै नम: तृप्तिरस्तु<hr />
२१४. कश्यप: अग्ने: उपजायत तस्मै नम: तृप्तिरस्तु</div>

</div></div>
<div className="tab blue">
    <input id="tab-12" type="radio" name="tabs2" />
    <label for="tab-12">Close - Sanskrit Text</label>
    <div className="tab-content">

      </div></div>
</div></div>

<hr className="new" />
 <h2>Deva Tarpanam - Upaveeti -as usual</h2>
 <div className="hint"> Keep poonal Upaveeti as usual.
    Keep two 'erukku' leaves and two dharbhams on that
    (as shown) and have some akshatai on it, and pour water a little
    for each manthram, water to be drop down<span style={{"backgroundColor": "yellow"}}>
        towards East</span>.
  </div>
  <div className="mydiv">
    <img src="assets/img/sama-deva-tarpanam.jpg" style={{"width": "90%"}} />
  </div>
  <div className="english">
215.agniḥ indrāt upajāyata tasmainamaḥ tṛptirastu <hr />
216.indraḥ vāyoḥ upajāyata tasmainamaḥ tṛptirastu <hr />
217.vāyuḥ mṛtyoḥ upajāyata tasmainamaḥ tṛptirastu <hr />
218.mṛtyuḥ prajāpateḥ upajāyata tasmainamaḥ tṛptirastu <hr />
219.prajāpatiḥ brahmaṇaḥ upajāyata tasmainamaḥ tṛptirastu <hr />
220.brahmā svayaṁbhūḥ tasmai namaḥ
			tebhyo namaḥ </div>

      <div className="wrapper">

          <div className="half">
            <div className="tab blue">
              <input id="tab-13" type="radio" name="tabs2" />
              <label for="tab-13">08-Sanskrit Text</label>
              <div className="tab-content">

      <div className="sans">
      देवतर्पणम्<hr />
      २१५. अग्नि: इन्द्रात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />
      २१६. इन्द्र: वायो: उपजायत तस्मै नम: तृप्तिरस्तु<hr />
      २१७. वायु: मृत्यो: उपजायत तस्मै नम: तृप्तिरस्तु<hr />
      २१८. मृत्यु: प्रजापते: उपजायत तस्मै नम: तृप्तिरस्तु<hr />
      २१९. प्रजापति: ब्रह्मण: उपजायत तस्मै नम: तृप्तिरस्तु<hr />
      २२०. ब्रह्मा स्वयंभू: तस्मै नम: तेभ्यो नम:। </div>

      </div></div>
      <div className="tab blue">
          <input id="tab-14" type="radio" name="tabs2" />
          <label for="tab-14">Close - Sanskrit Text</label>
          <div className="tab-content">

            </div></div>
      </div></div>

<hr className="new" />
 <h2>Rushi tharppaNam – Niveeti- poonal as   garland</h2>
 <div className="hint"> Keep poonal Upaveeti as usual.
     Keep two 'erukku' leaves and two dharbhams on that
     (as shown) and have some akshatai on it, and pour water a little
     for each manthram, water to be drop down<span style={{"backgroundColor": "yellow"}}>
         towards North</span>.
   </div>
<div className="mydiv">
    <img src="assets/img/sama-rishi-tarpanam.jpg" style={{"width": "90%"}} />
  </div>
 <div className="english">
221.nayan aryamabhūteḥ kālabavāt upajāyata tasmainamaḥ tṛptirastu <hr />
222.aryamabhūtiḥ kālabavaḥ bhadraśarmaṇaḥ 							kauśikāt upajāyata tasmainamaḥ tṛptirastu <hr />
223.bhadraśarmā kauśikaḥ puṣyayaśasaḥ 						audavrajeḥ upajāyata tasmainamaḥ tṛptirastu <hr />
224.puṣyayaśāḥ audavrajiḥ saṁkarāt gautamāt upajāyata tasmainamaḥ tṛptirastu <hr />

225.saṁkaraḥ gautamaḥ aryama rādhācca gobhilāt upajāyata tasmainamaḥ tṛptirastu <hr />

226.pūṣamitraḥ gobhilaḥ aśvamitrāt gobhilāt upajāyata tasmainamaḥ tṛptirastu <hr />

227.aśvamitraḥ gobhilaḥ varuṇamitrāt gobhilāt upajāyata tasmainamaḥ tṛptirastu <hr />

228.varuṇamitraḥ gobhilaḥ mūlamitrāt gobhilāt upajāyata tasmainamaḥ tṛptirastu <hr />

229.mūlamitraḥ gobhilaḥ vatsamitrāt gobhilāt upajāyata tasmainamaḥ tṛptirastu <hr />

230.vatsamitraḥ gobhilaḥ gaulgulavīputrāt gobhilāt upajāyata tasmainamaḥ tṛptirastu <hr />

231.gaulgulavīputraḥ gobhilaḥ
		bṛhadvasoḥ gobhilāt pituḥ upajāyata tasmainamaḥ tṛptirastu <hr />
232.bṛhadvasuḥ gobhilaḥ gobhilādeva upajāyata tasmainamaḥ tṛptirastu <hr />

233.gobhilaḥ rādhācca gautamāt upajāyata tasmainamaḥ tṛptirastu <hr />
234.rādhaḥ gautamaḥ saṁvargajit pituḥ upajāyata tasmainamaḥ tṛptirastu <hr />
235.gātā gautamaḥ saṁvargajitaḥ lāmakāyanāt  upajāyata tasmainamaḥ tṛptirastu <hr />

236.saṁvargajit lāmakāyanaḥ śākadāsāt 						bhāḍitāyanāt upajāyata tasmainamaḥ tṛptirastu <hr />
237.śākadāsaḥ bhāḍitāyanaḥ vicakṣaṇāt tāṇḍyāt  upajāyata tasmainamaḥ tṛptirastu <hr />

238.vicakṣaṇaḥ tāṇḍyaḥ gardabhīmukhāt 						śāṇḍilyāyanāt upajāyata tasmainamaḥ tṛptirastu <hr />
239.gardabhīmukhaḥ śāṇḍilyāyanaḥ udaraśāṇḍilyāt upajāyata tasmainamaḥ tṛptirastu <hr />

240.udara śāṇḍilyaḥ atidhanvanaśca śaunakāt 	maśakācca gārgyāt upajāyata tasmainamaḥ tṛptirastu <hr />
241.maśakaḥ gārgyaḥ sthirakāt gārgyāt pituḥ upajāyata tasmainamaḥ tṛptirastu <hr />
242.sthirakaḥ gārgyaḥ vāsiṣṭhāt caikitāneyāt upajāyata tasmainamaḥ tṛptirastu <hr />

243.vāsiṣṭhaḥ caikitāneyaḥ vāsiṣṭhāt
			āraihaṇyāt rājanyāt upajāyata tasmainamaḥ tṛptirastu <hr />
244.vāsiṣṭhaḥ āraihaṇyaḥ rājanyaḥ sumantrāt 					bābhravāt gautamāt upajāyata tasmainamaḥ tṛptirastu <hr />
245.sumantraḥ bābhravaḥ gautamaḥ śūṣāt vānheyāt bhāradvājāt upajāyata tasmainamaḥ tṛptirastu <hr />
246.śūṣaḥ vānheyaḥ bhāradvājaḥ arālāta
			dārteyāt śaunakāt  upajāyata tasmainamaḥ tṛptirastu <hr />
247.arālaḥ dārteyaḥ śaunakaḥ dṛteḥ aindrotāt 						śaunakāt pituḥ upajāyata tasmainamaḥ tṛptirastu <hr />
248.dṛtiḥ aindrotaḥ śaunakaḥ indrotāt
			śaunakāt pitureva upajāyata tasmainamaḥ tṛptirastu <hr />
249.indrotaḥ śaunakaḥ vṛṣaśuṣṇāt vātāvatāt upajāyata tasmainamaḥ tṛptirastu <hr />

250.vṛṣaśuṣṇaḥ vātāvataḥ nikothakāt bhāyajātyāt upajāyata tasmainamaḥ tṛptirastu <hr />

251.nikothakaḥ bhāyajātyaḥ pratitheḥ devatarathāt upajāyata tasmainamaḥ tṛptirastu <hr />

252.pratithiḥ devatarathaḥ devatarasaḥ
				śāvasāyanāt pituḥ upajāyata tasmainamaḥ tṛptirastu <hr />
253.devatarāḥ śāvasāyanaḥ śavasaḥ pitureva upajāyata tasmainamaḥ tṛptirastu <hr />
254.śavāḥ agnibhuvaḥ kāśyapāt upajāyata tasmainamaḥ tṛptirastu <hr />
255.agnibhūḥ kāśyapaḥ indrabhuvaḥ kāśyapāt upajāyata tasmainamaḥ tṛptirastu <hr />
256.indrabhūḥ kāśyapaḥ mitrabhuvaḥ kāśyapāt upajāyata tasmainamaḥ tṛptirastu <hr />
257.mitrabhūḥ kāśyapaḥ vibhaṇḍakāt kāśyapāt pituḥ upajāyata tasmainamaḥ tṛptirastu <hr />

258.vibhaṇḍakaḥ kāśyapaḥ ṛśyaśṛṁgāt
				kāśyapāt pitureva upajāyata tasmainamaḥ tṛptirastu <hr />
259.ṛśyaśṛṁgaḥ kāśyapaḥ kaśyapāt pitureva upajāyata tasmainamaḥ tṛptirastu <hr />

260.kaśyapaḥ agneḥ upajāyata tasmainamaḥ tṛptirastu </div>

<div className="wrapper">

    <div className="half">
      <div className="tab blue">
        <input id="tab-15" type="radio" name="tabs2" />
        <label for="tab-15">09-Sanskrit Text</label>
        <div className="tab-content">

<div className="sans">

ऋषि तर्पणम्<hr />
२२१. नयन् अर्यमभूते: कालबवात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />
२२२. अर्यमभति: कालबव: भद्रशर्मण: कौशिकौशिकात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२२३. भद्रशर्मा कौशिक: पुष्ययशस: औदव्रजे: उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२२४. पुष्ययशा: औदव्रजि: संकराात् गौतमात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२२५. संकर: गौतम: अर्यमराधाच्च गोभिलात्
	पूषमित्राच्च गोभिलात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />
२२६. पूषमित्र: गोभिल: अश्वमित्रात् गोभिलात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२२७. अश्वमित्र: गोभिल: वरुणमित्रात् गोभिलात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२२८. वरुणमित्र: गोभिल: मूलमित्रात् गोभिलात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२२९. मूलमित्र: गोभिल: वत्समित्रात् गोभिलात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२३०. वत्समित्र: गोभिल: गौल्गुलवीपुत्रात् गोभिलात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२३१. गौल्गुलवीपुत्र: गोभिल: बृहद्वसो: गोभिलात् पितु: उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२३२. बृहद्वसु: गोभिल: गोभिलादेव उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२३३. गोभिल: राधच्च गौतमात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />
२३४. राधा गौतम: गातु: गौतमात् पितु: उपजायत तस्मै नम: तृप्तिरस्तु<hr />
२३५. गाता गौतम: संवर्गजित: लामकायनात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२३६. संवर्गजित् लामकायन: शाकदासात् भाडितायनात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२३७. शाकदास: भाडितायन: विचक्षणात् ताण्डयात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२३८. विचक्षण: ताण्डय: गर्दभीमुखात् शाण्डिल्यायनात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२३९. गर्दभीमुख: शाण्डिल्यायन: उदरशाण्डिल्यात् पितु: उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२४०. उदर शाण्डिल्य: अतिधन्वनश्च शौनकात्
	मशकाश्च गार्ग्यात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />
२४१. मशक: गार्ग्य: स्थिरकात् गार्ग्यात् पितु: उपजायत तस्मै नम: तृप्तिरस्तु<hr />
२४२. स्थिरक: गार्ग्य: वासिष्ठात् चैकितानेयात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२४३. वासिष्ठ: चैकितानेय: वासिष्ठात् आरैहण्यात् राजन्यात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२४४. वासिष्ठ: आरैहण्य: राजन्य: सुमन्द्रात् बाभ्रवात्  गौतमात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२४५. सुमन्द्र: बाभ्रव: गौतम: शूषात् वान्हेयात् भारद्वाजात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२४६. शूष: वान्हेय: भारद्वाज: अरालात् दार्तेयात् शौनकात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२४७. अराल: दार्तेय: शौनक: दृते: ऐन्द्रोतात् शौनकात् पितु: उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२४८. दृति: ऐन्द्रोत: शौनक: इन्द्रोतात् शौनकात् पितुरेव उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२४९. इन्द्रोत: शौनक: वृषशुष्णात् वातावतात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२५०. वृषशुष्ण: वातावत: निकोथकात् भायजात्यात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२५१. निकोथक: भायजात्य: प्रतिथे: देवतरथात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२५२. प्रतिथि: देवतरथ: देवतरस: शावसायनात् पितु: उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२५३. देवतरा: शावसायन: शवस: पितुरेव उपजायत तस्मै नम: तृप्तिरस्तु<hr />
२५४. शवा: अग्निभुव: काश्यपात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />
२५५. अग्निभू: काश्यप: इन्द्रभुव: काश्यपात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />
२५६. इन्द्रभू: काश्यप: मित्रभुव: काश्यपात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />
२५७. मित्रभू:  काश्यप: विभण्डकात् काश्यपात् पितु: उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२५८. विभण्डक: काश्यप: ऋश्यशृंगात् काश्यपात् पितुरेव उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२५९. ऋश्यशृंग: काश्यप: कश्यपात् पितुरेव उपजायत तस्मै नम: तृप्तिरस्तु<hr />

२६०. कश्यप: अग्ने: उपजायत तस्मै नम: तृप्तिरस्तु<hr />
देवतर्पणम्
२६१. अग्नि: इन्द्रात् उपजायत तस्मै नम: तृप्तिरस्तु<hr />
२६२. इन्द्र: वायो: उपजायत तस्मै नम: तृप्तिरस्तु<hr />
२६३. वायु: मृत्यो: उपजायत तस्मै नम: तृप्तिरस्तु<hr />
२६४. मृत्यु: प्रजापते: उपजायत तस्मै नम: तृप्तिरस्तु<hr />
२६५. प्रजापति: ब्रह्मण: उपजायत तस्मै नम: तृप्तिरस्तु<hr />
२६७.ब्रह्मा स्वयंभू: तस्मै नम: तेभ्यो नम: उपजायत तस्मै नम: तृप्तिरस्तु
</div>

</div></div>
<div className="tab blue">
    <input id="tab-16" type="radio" name="tabs2" />
    <label for="tab-16">Close - Sanskrit Text</label>
    <div className="tab-content">

      </div></div>
</div></div>

<hr className="new" />
 <h2>Deva Tarpanam - Upaveeti -as usual</h2>
 <div className="hint"> Keep poonal Upaveeti as usual.
    Keep two 'erukku' leaves and two dharbhams on that
    (as shown) and have some akshatai on it, and pour water a little
    for each manthram, water to be drop down<span style={{"backgroundColor": "yellow"}}>
        towards East</span>.
  </div>
  <div className="mydiv">
    <img src="assets/img/sama-deva-tarpanam.jpg" style={{"width": "90%"}} />
  </div>
  <div className="english">
261.agniḥ indrāt upajāyata tasmainamaḥ tṛptirastu <hr />
262.indraḥ vāyoḥ upajāyata tasmainamaḥ tṛptirastu <hr />
263.vāyuḥ mṛtyoḥ upajāyata tasmainamaḥ tṛptirastu <hr />
264.mṛtyuḥ prajāpateḥ upajāyata tasmainamaḥ tṛptirastu <hr />
265.prajāpatiḥ brahmaṇaḥ upajāyata tasmainamaḥ tṛptirastu <hr />
266.brahmā svayaṁbhūḥ tasmai namaḥ tebhyo namaḥ </div>

<div className="wrapper">

    <div className="half">
      <div className="tab blue">
        <input id="tab-17" type="radio" name="tabs2" />
        <label for="tab-17">10-Sanskrit Text</label>
        <div className="tab-content">

<div className="sans">

देवतर्पणम्<hr />
२६१. अग्नि: इन्द्रात्
२६२. इन्द्र: वायो:
२६३. वायु: मृत्यो:
२६४. मृत्यु: प्रजापते:
२६५. प्रजापति: ब्रह्मण:
२६७.ब्रह्मा स्वयंभू: तस्मै नम: तेभ्यो नम:

</div>

</div></div>
<div className="tab blue">
    <input id="tab-18" type="radio" name="tabs2" />
    <label for="tab-18">Close - Sanskrit Text</label>
    <div className="tab-content">

      </div></div>
</div></div>

<hr className="new" />

<div className="hint">

</div>
  <div className="mydiv">
      <img src="assets/img/sama-pitru-tarpanam.jpg" style={{"width": "90%"}} />
    </div>
    <div className="english">
    1.pitṝṇāṁ  tṛptirastu<hr />
2.pitāmahānāṁ tṛptirastu<hr />
3.prapitāmahānāṁ tṛptirastu<hr />
4.mātṝṇāṁ tṛptirastu<hr />
5.mātāmahānāṁ tṛptirastu<hr />
6.pramātāmahānāṁ tṛptirastu<hr />
7.ācāryāṇāṁ tṛptirastu<hr />
8.prācāryāṇāṁ tṛptirastu<hr />
9.saṁhitākāra padakāra sūtrakāra
		brāhmaṇakārāṇāṁ tṛptirastu<hr />
10.brāhmaṇānāṁ anapatyānāṁ  tṛptirastu<hr />

11.brāhmaṇīnāṁ ekapatnīnāṁ  tṛptirastu<hr />

12.sarveṣāṁ ca brahmacāriṇāṁ tṛptirastu
</div>


<div className="wrapper">

    <div className="half">
      <div className="tab blue">
        <input id="tab-19" type="radio" name="tabs2" />
        <label for="tab-19">11-Sanskrit Text</label>
        <div className="tab-content">

<div className="sans">

१. पितृणां 	तृप्तिरस्तु			(त्रि:)<hr />
२. पितामहानां	तृप्तिरस्तु			(त्रि:)<hr />
३. प्रपितामहानां	तृप्तिरस्तु			(त्रि:)<hr />
४. मातृणां	तृप्तिरस्तु			(त्रि:)<hr />
५.मातामहानां	तृप्तिरस्तु			(त्रि:)<hr />
६. प्रमातामहानां	तृप्तिरस्तु			(त्रि:)<hr />
७. आचार्याणां	तृप्तिरस्तु			(त्रि:)<hr />
८. प्रचार्याणां	तृप्तिरस्तु			(त्रि:)<hr />
९. संहिताकार पदकार सूत्रकार ब्राह्मणकाराणां तृप्तिरस्तु (त्रि:)<hr />

१०. ब्राह्मणानां अनपत्यानां तृप्तिरस्तु			(त्रि:)<hr />

११. ब्राह्मणीनां एकपत्नीनां अनपत्यानां तृप्तिरस्तु	(त्रि:)<hr />

१२. सर्वेषां च ब्रह्मचारिणां तृप्तिरस्तु			(त्रि:)<hr />

</div>

</div></div>
<div className="tab blue">
    <input id="tab-20" type="radio" name="tabs2" />
    <label for="tab-20">Close - Sanskrit Text</label>
    <div className="tab-content">

      </div></div>
</div></div>

<div>
    <img src="assets/img/pavithram-in-ear.jpg" className="img2" />
  <div className="hint">Rushi tharpanam over! Next Vedha Aarambham.
   If you are doing it in your house, keep the pavithram in
   your right ear and do achamanam. If you are doing it in
   the bank of a river or a lake remove
  and untie  the pavithram and do achamanam twice.</div>
    </div>
    <div className="clear"></div>
    <hr />
    <div>
        <img src="assets/img/new-achamanam.gif" />
      </div>
      <hr className="new" />
      <div className="clear"></div>
      <div className="bigdiv">
        As per actual Sama practice, yajgnopaveetam should be worn
        at this place only. So, the manthrams are given here too.
      </div>
    {/*Look here*/}
    <div className="wrapper">

        <div className="half">
          <div className="tab blue">
            <input id="tab-23" type="radio" name="tabs2" />
            <label for="tab-23">Yagnopaveetha dharanam</label>
            <div className="tab-content">
            {/*Yajgnopaveeta Manthrams Start*/}
            <div className="prayogam">Chrowdha smartha vidhi vihitha nithya
                karma anushtana yogyadha
                  sidhyartham brahma thejaha abhiviruthiyartham yagnopaveetha
                  dharanam karishye! </div>
                <div className="sans">
                    मम श्रौतस्मार्त वितिविहित न्त्यिकर्म अनुष्टान योग्यता सिध्यर्थं ब्रह्मतेज:
                    अभिवृद्धयर्थं यज्ञोपवीत धारणं करिष्ये।
                </div>
                  <div className="hint"> (This is called sankalpam, after this leave the short
                   dharbhams on your left side i.e in north) </div>
                   <div className="head2">Yagnopaveetha dharana nyaasam :</div>

                   <div>
                       <img src="assets/img/Nyaasam1.jpg" className="img2" />

                       <div className="hint">Touch your fore head and tell :-</div>
                       <div className="prayogam">'Yagnopaveetha dhaarana manthrasya brahmaa rushi:</div>
                       <div className="sans">यज्ञोपवीत धारण मन्त्रस्य ब्रह्मा ऋषि:</div>
                     </div>

                     <div className="clear"></div>

                     <div>
                       <img src="assets/img/Nyaasam2.jpg" className="img2" />

                       <div className="hint">Touch your nose tip and tell :-</div>
                       <div className="prayogam">'Anushtup chandha:(ha)'</div>
                       <div className="sans">अनुष्टुप् छन्द:</div>

                     </div>
                     <div className="clear"></div>



                     <div>
                       <img src="assets/img/Nyaasam3.jpg" className="img2" />
                       <div className="hint">Touch your chest and tell :-</div>
                       <div className="prayogam">'Thrayee vidhya devadha'</div>
                       <div className="sans">त्रयीविद्या देवता</div>

                     </div>


                     <div>
                       <img src="assets/img/Nyaasam4.jpg" className="img2" />

                       <div className="hint">Roll both the palm towards your chest and tell :-
                       </div>
                       <div className="prayogam"> 'Yagnopaveetha dharane viniyoga:(ha)'</div>
                       <div className="sans">यज्ञोपवीत धारणे विनियोग:</div>
                     </div>
                    <div className="head2">Yagnopaveetha dhaaranam : </div>

                   <img src="assets/img/Poonal-BrahmaMudichu.jpg" />

                     <div>
                         <img src="assets/img/poonal-position.jpg" className="img2" />

                         <div className="hint">Hold the ‘poonal’ as shown in the picture and tell:- </div>
                   </div>
                   <div className="clear"></div>

                   <div>
                       <img src="assets/img/insert-poonal.jpg" className="img2" />

                     <div className="prayogam">‘Yagnopaveetham - paramam - pavithram -
                     prajapathe:(he) - yathsahajam - purasthath - aayushyam - agryam - prathimunjasubram -
                     yagnopaveetham - bhalamasthu - theja:(ha).' </div>
                   </div>
                   <div className="clear"></div>
                   <div className="sans">
                       यज्ञोपवीतम् परमं पवित्रं प्रजापते: यत्सहजं पुरस्तात् आयुष्यं
                       अग्रियं प्रतिमञ्चशुभ्रं यज्ञोपवीतं बलमस्तु तेज:
                   </div>

                     <div className="hint">insert right and take out left hand to place on left shoulder
                     and to hang under right hand.</div>



                     <div>
                        <img src="assets/img/pavithram-in-ear.jpg" className="img2" />
                        <div className="hint">Now brahmacharies should wait for a while when grahasthas are wearing the second poonal.<br />
                  Grahasthas remove and put the pavithram in the right ear and do one achamanam, then wear pavitram and do one praanayamam.</div>
                      </div>
                      <div className="clear"></div>

                  <div>
                    <hr className="new" />
                    <div className="clear"></div>
                  <img src="assets/img/praanaayaamam.gif" />
                  </div>


                    <div><img src="assets/img/sankalpam.jpg" className="img2" />
                    <div className="prayogam">Sri bhagavadhagnaya ..... m grahastha aasramaartham dvitheeya yagnopaveetha dhaaranam karishye! </div>
                       <div className="sans">
                          ग्रहस्त आश्रमार्थं िद्वतीय यज्ञोपवीत धारणं करिष्ये।
                       </div>
                       </div>

                  <div>
                      <img src="assets/img/Nyaasam1.jpg" className="img2" />

                      <div className="hint">Touch your fore head and tell :-</div>
                      <div className="prayogam">'Yagnopaveetha dhaarana manthrasya brahmaa rushi:</div>
                      <div className="sans">यज्ञोपवीत धारण मन्त्रस्य ब्रह्मा ऋषि:</div>
                    </div>

                    <div className="clear"></div>

                    <div>
                      <img src="assets/img/Nyaasam2.jpg" className="img2" />

                      <div className="hint">Touch your nose tip and tell :-</div>
                      <div className="prayogam">'Anushtup chandha:(ha)'</div>
                      <div className="sans">अनुष्टुप् छन्द:</div>

                    </div>
                    <div className="clear"></div>



                    <div>
                      <img src="assets/img/Nyaasam3.jpg" className="img2" />
                      <div className="hint">Touch your chest and tell :-</div>
                      <div className="prayogam">'Thrayee vidhya devadha'</div>
                      <div className="sans">त्रयीविद्या देवता</div>

                    </div>


                    <div>
                      <img src="assets/img/Nyaasam4.jpg" className="img2" />

                      <div className="hint">Roll both the palm towards your chest and tell :-
                      </div>
                      <div className="prayogam"> 'Yagnopaveetha dharane viniyoga:(ha)'</div>
                      <div className="sans">यज्ञोपवीत धारणे विनियोग:</div>
                    </div>
                   <div className="head2">Yagnopaveetha dhaaranam : </div>

                  <img src="assets/img/Poonal-BrahmaMudichu.jpg" />

                    <div>
                        <img src="assets/img/poonal-position.jpg" className="img2" />

                        <div className="hint">Hold the ‘poonal’ as shown in the picture and tell:- </div>
                  </div>
                  <div className="clear"></div>

                  <div>
                      <img src="assets/img/insert-poonal.jpg" className="img2" />

                    <div className="prayogam">‘Yagnopaveetham - paramam - pavithram -
                    prajapathe:(he) - yathsahajam - purasthath - aayushyam - agryam - prathimunjasubram -
                    yagnopaveetham - bhalamasthu - theja:(ha).' </div>
                  </div>
                  <div className="clear"></div>
                  <div className="sans">
                      यज्ञोपवीतम् परमं पवित्रं प्रजापते: यत्सहजं पुरस्तात् आयुष्यं
                      अग्रियं प्रतिमञ्चशुभ्रं यज्ञोपवीतं बलमस्तु तेज:
                  </div>

                    <div className="hint">insert right and take out left hand to place on left shoulder
                    and to hang under right hand.</div>




                    <div className="hint">Now brahmacharies & grahasthas remove the old poonal by saying :
                  </div>
                    <div className="prayogam">“Upaveetham - bhinnadhanthum - jeernam - kasmaladhooshitham - visrujami -
                  jalebrahmannu - varcha:(ha) - dheerghayu:(hu) - ashthume!” </div>
                      <div className="sans">
                          उपवीतं भिन्नतन्तुं जीर्णं कश्मलदूषितम्।<br />
                          विसृजामि जले ब्रह्मन् वर्च: दीर्घायु: अस्तु मे।।
                      </div>

                  <div>
                      <img src="assets/img/pavithram-in-ear.jpg" className="img2" />
                    <div className="hint"> After removing the old poonal,
                      put the pavithram in the right ear
                    do one achamanam </div>
                      </div>
                      <div className="clear"></div>
                    </div>

      {/*Yajgnopaveeta Manthrams End*/}


    </div></div>
    <div className="tab blue">
        <input id="tab-24" type="radio" name="tabs2" />
        <label for="tab-24">skip yajgnopaveetam</label>
        <div className="tab-content">

          </div></div>
    </div>{/* Accordion End*/}
    <div className="wrapper">

        <div className="half">
          <div className="tab blue">
            <input id="tab-25" type="radio" name="tabs2" />
            <label for="tab-25">Brahmachari -Vishayam</label>
            <div className="tab-content">
    <h2>Brahmachari Mekala dharana mantram</h2>
    <div className="english">
     iyam dhuruktaat paribaadhamaana varNam pavitram punateena: aagaat|<hr />
     praaNaa apanaabhyaam balamaahranti svasaa devee: subhagaa mekalaa iyam |<hr />
     rutasya gopthree tapasa: parsvee gnateeraksha: sahamaanaa araathee:|<hr />
     saamaa samantam abhiparyehi bhadhre dharthaaraste mekale maarishaama||
     </div>
     <div className="sans">
    मेखला धारणम्।
    "इयं दुरुक्तात् परिबाधमान वर्णं पवित्रं पुनतीन: आगात्।<hr />
     प्रणा अपानाभ्यां बलमाहरन्ति स्वसा देवी: सुभगा मेखला इयम्। <hr />
     ऋतस्य गोप्त्री तपस: परस्वी घ्नतीरक्ष: सहमाना अराती: । <hr />
     सामा समन्तं अभिपर्येहि भद्रे धर्तारस्ते मेखले मारिषाम।
     </div>
     <h2>Brahmachari - Ajina, Dhanda dharana Mantram</h2>
     <div className="english">
     Brahmachari should tie a bit of deer skin in his yajgnopaveetam by telling just "Om".<br />
      </div>
      <div className="hint">
      keep hold the dhandam or a 'samittu' (a 30 inch long stick plucked from the tree called 'purasai' or 'arasu' )
      by telling the below mantram.
      </div>
      <div className="english">
      suravasa: suravasam maa kuuru yathaatvam suravasa: susravaa: deveshu evamaham suravasa:
      susravaa: braahmaneshu bhooyaasam.
      </div>

    </div></div>


    <div className="tab blue">
        <input id="tab-26" type="radio" name="tabs2" />
        <label for="tab-26">Close - Sanskrit Text</label>
        <div className="tab-content">

          </div></div>
    </div></div>
      {/* Look here*/}
  <div className="head2">Vedha - Aarambham</div>
  <div>
      <img src="assets/img/Sankalpam.jpg" className="img2" />
      <div className="hint">
    Sit in a clean place towards east. Chant the below manthrams.
      </div>
  <div className="prayogam">"sri ... m, proshtapatyaam hastharkshe adhyaaya upaakarmani
    Vedhaarambam karishye."</div>
  <div className="sans">श्री ...म्। प्रोष्ठपद्यां हस्तर्क्षे अध्याय उपाकर्मणि वेदारंभम् करिष्ये ।।

    </div>
  <div className="hint">after this sankalpam,
  chant the below veda mantras with its swaram
  if you know well.</div>
</div>
<div className="clear"></div>

  <div className="prayogam">
  “Om tatsaviturvareanyam ..... (gayatri samam 3 times)”<br />
Om ..... bhoohu (vyaahruti samam - 4)<br />
somam raajaaanaam ....<br />
agnaaayaahi .....<br />
tatvo gaaya sute ....<br />
uchchaatejaata .....<br />
indhrajyesta...<br />
agna aayoogumshi ....<br />
upasmai .....<br />
mahanmevocha: bhargomevocha: Om|
sthomo yujyate satriyobhyo havirbhya:|
Om| prajaapatirvaa idameka ....</div>

<div className="hint">
It is hard to type it in English, please try to
recite from Sanskrit or in Tamil.
  </div>
  <div className="sans">
      विद्युदसि विद्यमे पाप्मानं ऋतात् सत्यमुपैमि ।।<hr />
      हरि: ॐ। <hr />
      महन्मेवोच: भगोमेवोच: ओम्।<hr />
      स्तोमो युज्यते सत्रियोभ्यो हविर्भ्य: ओम्।<hr />
      प्रजापतिर्वा इदमेक आसीत् ओम्।<hr />
      तृवृत् बहिष्पवमानं पञ्चदश अन्याज्यानि। ओम्।<hr />
      अतिरात्र: पृष्टष्षडह:। ओम्।<hr />
      ब्रह्म च वा इदमग्रे सुब्रह्म चास्ताम्। ओम्।<hr />
      ब्रह्महवा इदमग्र आसीत् ।  ओम्।<hr />
      अथ खल्वयम् आर्षप्रदेश: भवति।  ओम्।<hr />
      अग्रिरन्द्र: प्रजापति:।  ओम्।<hr />
      देवसवित: प्रसुव यज्ञम्।।  ओम्।<hr />
      ओमित्येतत् अक्षरम् उद्गाीथमुपासीत।  ओम्।<hr />
      असौ वा ाादित्यो देव मधु ।।  ओम्।<hr />
      यो ह वै ज्येष्ठं च श्रेष्ठं च वेद।  ओम्।<hr />
      अथात: संहितोपनिषदो व्याख्यास्याम:।  ओम्।<hr />
      नमो ब्रह्मणे नमो ब्रह्मणेभ्य:।  ओम्।<hr />
      अथातो विद्ध्यव्यपदेशे।  ओम्।<hr />
      अथातश्छन्दसां विचयं व्याख्यास्याम:।  ओम्।<hr />
      अथात: स्तोमान् व्याख्यास्याम:।  ओम्।<hr />
      क्लुप्तो ज्योतिष्टोमोऽति रात्रोऽषोडशिक:।  ओम्।
      <br />
      अथ संपत्सििद्धरनादेशे। ओम्।<hr />
आथात: प्रतिहारस्य।  ओम्।<hr />
ग्रामकामस्य क्लुप्तो ज्योत्ष्टोिम:।  ओम्।<hr />
क्लुप्तो ज्योत्ष्ठोिमे अतिरात्रप्रतिराष्ट्रं च।  ओम्।<hr />
अग्न आयानुदात्तम।  ओम्।<hr />
अग्नेझोतूतू।  ओम्।<hr />
अथ तालव्यामाइ यद्वृद्धम्।  ओम्।<hr />
अग्निमीले पुरोहितम्।   ओम्।<hr />
इषेत्वोर्जेत्वा।   ओम्।<hr />
शन्नोदेवीरभिष्टये ।   ओम्।<hr />
अइउण्। ऋलृक्। एओङ् ऐओच्।   ओम्।<hr />
गीर्णश्रेय: ।   ओम्। आद्यं पुरुषमीशानम्।   ओम्।<hr />
मनुमेकाग्रमासीनम्।   ओम्।<hr />
तप: स्वाध्याय निरतम।   ओम्।<hr />
वेदो धर्ममूलम्।   ओम्।<hr />
वेदोऽखिलो धर्ममूलम्।   ओम्।<hr />
अथातो धर्मजिज्ञासा।   ओम्।<hr />
अथातो ब्रह्मजिज्ञासा।   ओम्।<hr />
वृष्टिरसि वरश्च मे पाप्मानमृतात् सत्यमुपागाम्।।


    </div>

<hr />
  <div className="mydiv">Vadakalai only should say :-
  <div className="prayogam">
  “Bhagavaneva swasesha
  bhoothamidham upakarmakyam karma swasmai
  swapreethaye bhagavan swayameva kaarithavaan”</div>
  <div className="hint">If anybody still wearing the pavithram,
  remove and untie it and throw it.
   All should do achamanam twice.</div>
  </div>
<hr />

          <img src="assets/img/shastanga-namaskaram.jpg" className="img1" />

        <div className="hint">
          get up and do namaskaram as per sampradayam
           </div>
           <div className="clear"></div><hr />
        <img src="assets/img/abhivathi.jpg" className="img1" />

        <div className="hint">
          do abhivadhi.</div>
          <div className="clear"></div><hr />

 <hr />



<div>
  <img src="assets/img/kaikoopu.jpg" className="img2" />
  <div className="hint">Keep hands as doing namaskaram and  tell</div>
</div>
<div className="clear"></div><hr />
    <hr />
    <div className="svk">
      all can recite
    </div>
<div className="prayogam">
  ”
 “Kaayena vaacha - manase -
 indhriyarvaa - bhudhya - athmanaava - prahrudhe:(he) - swabhavaadh -
  karomi - yathyadh - sakalam - parasmai - sriman naarayanayethi - samarpayami”
“Sarvam Sri Krishnarpanam asthu. Achydha preeyatham”.
</div>
<div className="sans">
  कायेन वाचा मनसेन्द्रियैर्वा ।
  <br /> बुद्ध्यात्मना वा प्रकृतिस्वभावात् ।
  <br /> करोमि यद्यत्सकलं परस्मै ।
  <br /> नारायणयेति समर्पयामि ॥
</div>
<hr />
<div className="hint">
If you did the upakarma
in a common place and returnin to house, ask the ladies to take harathi.

    <hr />
    This is the end of Upakarma.
    </div>
<hr />
<div className="svk">First you go to the perumal (pooja) room and do namaskaram to permal
and then do namaskaram to periyavals (elders).
 If possible call relatives and friends to your house and
 take food with them. Enjoy this day.</div>
  <div className="item"> I pray Emperuman to bless all your family
  with good health and longivity with all desirable good things
  throughout your life. Be happy with parents, relatives and friends.
  Blessings or Wishses.
  <br />
 Dasan<br />
  Vadhyar - Dr.NVS </div>
<hr />
    </div>
  </div>
</div>

  );
}
